const ms = {
  common: {
    remove: "Buang",
    portal: "Portal",
    role: "Peranan",
    quantity: "Kuantiti",
    amount: "Jumlah",
    date: "Tarikh",
    label: "Label",
    change: "Tukar",
    campaignName: "Nama Kempen",
    createdBy: "Dicipta Oleh",
    method: "Kaedah",
    openingDate: "Tarikh Buka",
    closingDate: "Tarikh Tutup",
    production: "Pengeluaran",
    packing: "Pembungkusan",
    payments: "Pembayaran",
    totalOrders: "Jumlah Pesanan",
    totalRevenue: "Jumlah Hasil",
    activeCampaigns: "Kempen Aktif",
    totalMembers: "Jumlah Ahli",
    buyerName: "Nama Pembeli",
    totalPrice: "Jumlah Harga",
    orderId: "ID Pesanan",
    customer: "Pelanggan",
    order: "Pesanan",
    appName: 'Cheeco',
    english: 'Bahasa Inggeris',
    language: 'Bahasa',
    languageDescription: 'Pilih bahasa paparan untuk pelayar ini.',
    languageSaved: 'Keutamaan bahasa telah dikemas kini.',
    save: 'Simpan',
    saving: 'Sedang menyimpan...',
    saveSettings: 'Simpan Tetapan',
    cancel: 'Batal',
    processing: 'Sedang memproses...',
    reject: 'Tolak',
    confirm: 'Sahkan',
    delete: 'Padam',
    deleting: 'Sedang memadam...',
    deleteRecord: 'Padam Rekod',
    deleteRecordConfirmation: 'Adakah anda pasti mahu memadam rekod ini? Tindakan ini tidak mudah dibuat asal.',
    closeNotification: 'Tutup notifikasi',
    savedSuccessfully: 'Rekod berjaya disimpan.',
    requiredWarning: 'Sila lengkapkan semua medan wajib.',
    saveError: 'Tidak dapat menyimpan rekod. Sila cuba lagi.',
    importSuccess: 'Import CSV berjaya diselesaikan.',
    backToDashboard: 'Kembali ke Papan Pemuka',
    backToLogin: 'Kembali ke Log Masuk',
    continueToLogin: 'Teruskan ke Log Masuk',
    loading: 'Sedang memuatkan...',
    search: 'Cari',
    all: 'Semua',
    status: 'Status',
    actions: 'Tindakan',
    name: 'Nama',
    class: 'Kelas',
    age: 'Umur',
    email: 'E-mel',
    phone: 'Telefon',
    address: 'Alamat',
    product: 'Produk',
    products: 'Produk',
    campaign: 'Kempen',
    campaigns: 'Kempen',
    staff: 'Staf',
    vendors: 'Vendor',
    order: 'Pesanan',
    orders: 'Pesanan',
    member: 'Ahli',
    members: 'Ahli',
    settings: 'Tetapan',
    reports: 'Laporan',
    roles: 'Peranan',
    dashboard: 'Papan Pemuka',
    invoice: 'Invois',
    printPdf: 'Cetak PDF',
    downloadPdf: 'Muat Turun PDF',
    printInvoice: 'Cetak Invois',
    downloadInvoice: 'Muat Turun Invois',
    paymentStatus: 'Status Pembayaran',
    paymentMethod: 'Kaedah Pembayaran',
    paid: 'Dibayar',
    pending: 'Menunggu',
    failed: 'Gagal',
    approved: 'Diluluskan',
    rejected: 'Ditolak',
    draft: 'Draf',
    closed: 'Ditutup',
    open: 'Dibuka',
    noResults: 'Tiada keputusan ditemui.',
    noSettings: 'Tiada tetapan tersedia.',
    unableToLoad: 'Tidak dapat memuatkan data.',
    unableToSave: 'Tidak dapat menyimpan perubahan.',
    updated: 'Perubahan berjaya dikemas kini.',
    sessionExpired: 'Sesi telah tamat. Sila log masuk semula.',
    accessDenied: 'Akses ditolak.',
    forbiddenPermission: 'Akses ditolak: anda tidak mempunyai kebenaran yang diperlukan.',
    selectFileFirst: 'Sila pilih fail terlebih dahulu.',
    chooseLanguage: 'Pilih bahasa',
    myProfile: 'Profil Saya',
    openNavigation: 'Buka navigasi',
    logout: 'Log Keluar',
    user: 'Pengguna',
    currentUser: 'Pengguna Semasa',
    organizationNavigation: 'Navigasi organisasi',
    organizationLabel: 'Organisasi',
    categories: 'Kategori',
    inventory: 'Inventori',
    paymentCenter: 'Pusat Pembayaran',
    pendingApprovals: 'Kelulusan Menunggu',
    viewAll: 'Lihat Semua',
    storeApprovals: 'Kelulusan Kedai',
    campaignReviews: 'Semakan Kempen',
    memberReports: 'Laporan Ahli',
    bids: 'Tawaran',
    activityLogs: 'Log Aktiviti',
    printLabels: 'Cetak Label',
    platformProducts: 'Produk Platform',
    registerOrganization: 'Daftar Organisasi',
    registerSchool: 'Daftar Sekolah',
    claimOrganization: 'Tuntut Organisasi Anda',
    signIn: 'Log Masuk',
    organizationPortal: 'Portal Organisasi',
    schoolPortal: 'Portal Sekolah',
    parentPortal: 'Portal Ibu Bapa',
    vendorPortal: 'Portal Vendor',
    platformPortal: 'Portal Platform',
    yes: 'Ya',
    no: 'Tidak',
    bag: 'Beg',
    profile: 'Profil',
    searchAnything: 'Cari apa-apa...',
    superAdmin: 'Pentadbir Super',
    memberStudent: 'Murid',
    memberGeneric: 'Ahli',
    administrator: 'Pentadbir',
    principal: 'Pengetua',
    president: 'Presiden',
    company: 'Syarikat',
    employee: 'Pekerja',
    manager: 'Pengurus',
    business: 'Perniagaan',
    owner: 'Pemilik',
    volunteer: 'Sukarelawan',
    coordinator: 'Penyelaras',
    statusLabels: {
    submitted: "Dihantar",
    published: "Diterbitkan",
    open: "Terbuka",
      draft: 'Draf',
      rfq_open: 'RFQ Dibuka',
      closed: 'Ditutup',
      pending: 'Menunggu',
      pending_setup: 'Menunggu Persediaan',
      active: 'Aktif',
      disabled: 'Dinyahaktif',
      suspended: 'Digantung',
      awarded: 'Dianugerahkan',
      not_awarded: 'Tidak Dianugerahkan',
      production: 'Pengeluaran',
      packaging: 'Pembungkusan',
      packing: 'Pembungkusan',
      delivery: 'Penghantaran',
      ready_for_delivery: 'Sedia Untuk Penghantaran',
      delivered: 'Dihantar',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
      archived: 'Diarkibkan',
      paid: 'Dibayar',
      paid_online: 'Dibayar Dalam Talian',
      organization_paid: 'Dibayar Organisasi',
      manual_verified: 'Disahkan Manual',
      awaiting_approval: 'Menunggu Kelulusan',
      failed: 'Gagal',
      refunded: 'Dibayar Balik',
      super_admin: 'Pentadbir Super',
      platform_admin: 'Pentadbir Platform',
      tenant_admin: 'Pentadbir',
      buyer: 'Pembeli',
      vendor: 'Vendor',
      independent_seller: 'Penjual Bebas',
      school: 'Sekolah',
      pending_approval: 'Menunggu Kelulusan',
      requested_info: 'Maklumat Diminta',
      approved: 'Disahkan',
      rejected: 'Ditolak',
    },
    action: 'Tindakan',
    active: 'Aktif',
    close: 'Tutup',
    description: 'Keterangan',
    edit: 'Sunting',
    inactive: 'Tidak Aktif',
    independentPortal: 'Portal Bebas',
    next: 'Seterusnya',
    of: 'daripada',
    organizationAdminLogin: 'Log Masuk Pentadbir Organisasi',
    organizations: 'Organisasi',
    previous: 'Sebelumnya',
    showing: 'Menunjukkan',
    size: 'Saiz',
    stock: 'Stok',
    to: 'hingga',
    unknown: 'tidak diketahui',
    workspace: 'Ruang Kerja',
    back: 'Kembali',
    continue: 'Teruskan',
    parent: 'Ibu Bapa',
    school: 'Sekolah',
  },
  auth: {
    forgotPassword: 'Lupa Kata Laluan',
    resetPassword: 'Tetapkan Semula Kata Laluan',
    sendResetLink: 'Hantar Pautan Tetapan Semula',
    newPassword: 'Kata Laluan Baharu',
    confirmPassword: 'Sahkan Kata Laluan',
    emailAddress: 'Alamat E-mel',
    tokenMissing: 'Token tetapan semula tiada. Sila minta pautan tetapan semula kata laluan yang baharu.',
    resetSuccess: 'Kata laluan berjaya dikemas kini. Sila log masuk semula.',
    resetFailed: 'Tidak dapat menetapkan semula kata laluan.',
    resetLinkSent: 'Jika akaun dengan e-mel tersebut wujud, kami telah menghantar pautan tetapan semula kata laluan.',
    resetLinkFailed: 'Tidak dapat menghantar pautan tetapan semula. Sila cuba lagi.',
    loginFailed: 'Log masuk gagal. Sila semak maklumat anda.',
    parentPortalRequired: 'Akaun ibu bapa mesti log masuk melalui Portal Ibu Bapa.',
    serverUnavailable: 'Tidak dapat menyambung ke pelayan. Sila semak domain atau API dan cuba lagi.',
    emailVerified: 'E-mel Disahkan',
    emailVerifiedDescription: 'Alamat e-mel anda berjaya disahkan.',
    verificationProcessed: 'Permintaan pengesahan anda telah diproses.',
    verificationContinue: 'Anda kini boleh terus menggunakan Cheeco dengan alamat e-mel ini.',
    signIn: 'Log masuk',
    emailRequired: 'E-mel diperlukan',
    enterValidEmail: 'Sila masukkan alamat e-mel yang sah',
    enterYourEmail: 'Masukkan e-mel anda',
    emailPlaceholder: 'anda@contoh.com',
    checkYourEmail: 'Semak E-mel Anda',
    magicLinkSent: 'Pautan Ajaib Dihantar',
    weSentMagicLinkTo: 'Kami menghantar pautan ajaib ke',
    weSentNewMagicLinkTo: 'Kami menghantar pautan ajaib baharu ke',
    checkYourInbox: 'Sila semak peti masuk anda.',
    linkExpiresIn10: 'Pautan tamat tempoh dalam 10 minit dan hanya boleh digunakan sekali.',
    requestAnotherLinkIn: 'Anda boleh meminta pautan lain dalam',
    minutes: 'minit',
    sendingMagicLink: 'Sedang menghantar pautan ajaib',
    resendMagicLink: 'Hantar Semula Pautan Ajaib',
    sending: 'Sedang menghantar...',
    didntReceive: 'Tidak menerimanya? Klik untuk menghantar semula',
    useDifferentEmail: 'Gunakan e-mel berbeza',
    useDifferentEmailTitle: 'Gunakan E-mel Berbeza',
    emailAlreadyRegistered: 'E-mel ini sudah didaftarkan',
    noPasswordNeeded: 'Tiada kata laluan diperlukan. Kami akan menghantar pautan ajaib yang selamat kepada anda.',
    passwordlessCommerce: 'Komersial Sekolah Tanpa Kata Laluan',
    passwordlessCommerceTagline: 'Cheeco — Komersial Sekolah Tanpa Kata Laluan',
    welcomeToCheeco: 'Selamat Datang ke Cheeco',
    tellUsWhoYouAre: 'Beritahu kami siapa anda, kemudian masukkan e-mel untuk meneruskan.',
    iAmRegisteringAs: 'Saya mendaftar sebagai',
    continueWithEmail: 'Teruskan dengan e-mel',
    backToHome: 'Kembali ke Rumah',
    requestTooLong: 'Permintaan mengambil masa terlalu lama. Sila semak sambungan anda dan cuba lagi.',
    couldNotReach: 'Kami tidak dapat menghubungi Cheeco. Sila semak sambungan internet anda dan cuba lagi.',
    tooManyAttempts: 'Terlalu banyak percubaan. Sila tunggu beberapa minit dan cuba lagi.',
    checkEmailEntered: 'Sila semak e-mel yang anda masukkan dan cuba lagi.',
    serverUnavailableShort: 'Pelayan kami tidak tersedia buat sementara waktu. Sila cuba lagi dalam beberapa minit. Jika masalah berterusan, hubungi support@cheeco.com.',
    unexpectedError: 'Sesuatu yang tidak dijangka berlaku. Sila cuba lagi.',
    enterEmailAddress: 'Sila masukkan alamat e-mel anda.',
    enterValidEmailWithExample: 'Sila masukkan alamat e-mel yang sah (cth. nama@domain.com).',
    tooManyWait: 'Terlalu banyak percubaan. Sila tunggu sebelum meminta pautan lain.',
    failedToSend: 'Gagal menghantar pautan ajaib. Sila cuba lagi.',
    retryIn: 'Cuba semula dalam',
    wait: 'Tunggu',
    sendMeNewLink: 'Hantar Pautan Ajaib Baharu kepada Saya',
    linkExpired: 'Pautan Tamat Tempoh',
    linkExpiredDescription: 'Pautan ajaib ini telah tamat tempoh. Demi keselamatan, pautan hanya sah selama 10 minit. Sila minta yang baharu.',
    linkAlreadyUsed: 'Pautan Telah Digunakan',
    linkAlreadyUsedDescription: 'Pautan ajaib ini telah digunakan. Setiap pautan ajaib hanya boleh digunakan sekali demi keselamatan. Sila minta yang baharu.',
    invalidLink: 'Pautan Tidak Sah',
    invalidLinkDescription: 'Pautan ini kelihatan tidak sah atau rosak. Sila minta pautan ajaib baharu.',
    tokenNotFound: 'Token Tidak Ditemui',
    tokenNotFoundDescription: 'Token pautan ajaib tidak ditemui. Ia mungkin telah digunakan atau dipadam. Sila minta yang baharu.',
    noLinkFound: 'Tiada Pautan Ditemui',
    noLinkFoundDescription: 'Tiada token pengesahan ditemui dalam URL. Sila minta pautan ajaib baharu.',
    networkError: 'Ralat Rangkaian',
    networkErrorDescription: 'Kami tidak dapat menghubungi pelayan untuk mengesahkan pautan anda. Ini sering disebabkan oleh service worker lapuk. Sila muat semula paksa (Ctrl+Shift+R) dan cuba lagi.',
    requestTimeoutTitle: 'Permintaan Tamat Masa',
    requestTimeoutDescription: 'Permintaan pengesahan tamat masa. Sila cuba lagi.',
    connectionError: 'Ralat Sambungan',
    connectionErrorDescription: 'Kami tidak dapat mengesahkan pautan anda kerana anda nampaknya berada di luar talian. Sila semak sambungan anda dan cuba lagi.',
    tooManyRequests: 'Terlalu Banyak Permintaan',
    tooManyRequestsDescription: 'Terlalu banyak percubaan pengesahan. Sila tunggu beberapa minit sebelum mencuba lagi.',
    serverError: 'Ralat Pelayan',
    serverErrorDescription: 'Pelayan kami menghadapi ralat semasa mengesahkan pautan anda. Sila cuba lagi dalam beberapa minit. Jika masalah berterusan, hubungi sokongan.',
    linkInvalidOrExpired: 'Pautan Tidak Sah atau Tamat Tempoh',
    linkInvalidOrExpiredDescription: 'Pautan ajaib ini tidak sah, tamat tempoh, atau telah digunakan. Sila minta yang baharu.',
    needHelpContact: 'Perlu bantuan? Hubungi pentadbir sekolah anda atau',
    needHelpFull: 'Perlu bantuan? Hubungi pentadbir sekolah anda atau sokongan Cheeco.',
    cheecoSupport: 'sokongan Cheeco',
    noTokenProvided: 'Tiada token pengesahan diberikan. Sila minta pautan ajaib baharu.',
    malformedLink: 'Pautan ini kelihatan rosak. Sila minta pautan ajaib baharu.',
    verificationFailed: 'Pengesahan gagal. Sila cuba lagi.',
    multipleRetryFailed: 'Banyak percubaan semula gagal. Sila minta pautan ajaib baharu.',
    verifyingYourLink: 'Sedang mengesahkan pautan anda...',
    pleaseWaitVerify: 'Sila tunggu sementara kami mengesahkan pautan ajaib anda.',
    thisMayTakeSeconds: 'Ini mungkin mengambil masa beberapa saat',
    loginSuccessful: 'Log Masuk Berjaya',
    redirectingToDashboard: 'Mengalihkan anda ke papan pemuka...',
    magicLinksExpire: 'Pautan ajaib tamat tempoh selepas 10 minit demi keselamatan. Sila minta yang baharu.',
    linkAlreadyUsed2: 'Pautan ini telah digunakan. Setiap pautan ajaib hanya boleh digunakan sekali.',
    multipleAttemptsFailed: 'Banyak percubaan gagal. Ini mungkin disebabkan oleh masalah rangkaian atau pautan telah tamat tempoh.',
    tryAgain: 'Cuba Lagi',
    requestNewLink: 'Minta Pautan Baharu',
    verifyingSecureLink: 'Mengesahkan pautan selamat...',
    signingYouIn: 'Sedang log masuk...',
    redirecting: 'Mengalihkan...',
    organisationAccess: 'Akses Organisasi',
    organisationAdminLogin: 'Log Masuk Pentadbir Organisasi',
    organisationSuperAdminLogin: 'Log Masuk Super Pentadbir Organisasi',
    organisationMemberUser: 'Ahli / Pengguna Organisasi',
  },
  orders: {
    title: 'Pesanan',
    listTitle: 'Senarai Pesanan dan Borang Pesanan Manual',
    description: 'Pentadbir organisasi boleh mencipta pesanan manual apabila pembeli memerlukan bantuan menggunakan sistem.',
    myOrders: 'Pesanan Saya',
    buyer: 'Pembeli',
    size: 'Saiz',
    quantity: 'Kuantiti',
    amount: 'Jumlah',
    type: 'Jenis',
    completed: 'Selesai',
    pay: 'Bayar',
    manualOrder: 'Pesanan Manual',
    addManualOrder: 'Tambah Pesanan Manual',
    selectProduct: 'Pilih Produk Organisasi',
    noActiveProducts: 'Tiada produk aktif tersedia untuk organisasi ini.',
    paymentPending: 'Belum Dibayar (Menunggu)',
    paymentPaidCash: 'Dibayar (Tunai)',
    paymentDeposit: 'Bayaran Sebahagian (Deposit)',
    submitOrder: 'Hantar Pesanan',
    submitting: 'Sedang menghantar...',
    pdfLabelsFailed: 'Tidak dapat menjana label PDF.',
    labelsReady: '{{count}} label sedia untuk dicetak.',
    onlineBuyer: 'Pembeli Dalam Talian',
    adminManual: 'Manual Pentadbir',
    noOrders: 'Tiada pesanan ditemui.',
    noMatchingOrders: 'Tiada pesanan sepadan ditemui.',
    searchPlaceholder: 'Cari pesanan, pembeli, kelas, saiz, jumlah',
  },
  parent: {
    school: 'Sekolah',
    familyDashboardFailed: 'Tidak dapat memuatkan papan pemuka keluarga.',
    memberAdded: 'Ahli berjaya ditambah.',
    duplicateMerged: 'Rekod ahli pendua berjaya digabungkan.',
    memberAddFailed: 'Tidak dapat menambah ahli.',
    profileUpdated: 'Profil dikemas kini.',
    fullName: 'Nama Penuh',
    yourName: 'Nama anda',
    yourEmail: 'anda@contoh.com',
    phoneNumber: 'Nombor telefon',
    yourAddress: 'Alamat anda',
    languageUpdated: 'Bahasa dikemas kini.',
    saveChanges: 'Simpan Perubahan',
    manageFamily: 'Urus Ahli Keluarga',
    noFamilyMembers: 'Tiada ahli keluarga ditambah lagi.',
    addFamilyMember: 'Tambah Ahli Keluarga',
    relationship: 'Hubungan',
    memberName: 'Nama Ahli',
    enterName: 'Masukkan nama',
    classPlaceholder: 'cth. 5 Aman',
    adding: 'Sedang menambah...',
    myKids: 'Anak-Anak Saya',
    addStudent: 'Tambah Pelajar',
    addStudentDescription: 'Tambah maklumat anak anda.',
    studentName: 'Nama Pelajar',
    studentNamePlaceholder: 'cth. Ahmad Hakimi',
    classLabel: 'Kelas',
    classPlaceholderStudent: 'cth. 3 Amanah',
    sportsHouse: 'Rumah Sukan',
    selectSportsHouse: 'Pilih Rumah Sukan',
    mySchools: 'Sekolah Saya',
    students: 'Pelajar',
    manage: 'Urus',
    connectSchool: 'Sambung Sekolah Lain',
    edit: 'Sunting',
    noOrganizationProducts: 'Organisasi ini belum mempunyai produk untuk pesanan.',
    productNotFound: 'Produk organisasi tidak ditemui untuk pesanan.',
    organization: 'Organisasi',
    organizationGroupsDescription: 'Setiap organisasi memaparkan bilangan ahli, produk aktif, kemajuan dan pengumuman.',
    addMemberFirst: 'Tambah ahli anda dahulu. Papan pemuka akan mengumpulkan pesanan mengikut organisasi.',
    noActiveProductsForOrganization: 'Ahli telah ditambah, tetapi organisasi yang dipautkan belum mempunyai produk aktif.',
    addMemberToSeeOrganization: 'Tambah ahli untuk melihat butiran organisasi.',
    organizationProductsAvailable: 'Produk organisasi tersedia',
    noActiveProducts: 'Tiada produk aktif tersedia untuk organisasi ini.',
    noProductsAvailable: 'Tiada produk tersedia sekarang. Produk akan muncul apabila Pentadbir Organisasi anda menerbitkannya.',
    noOrdersTitle: 'Belum ada pesanan',
    noOrdersForMember: 'Ahli ini belum mempunyai pesanan yang direkodkan.',
    noFamilyOrders: 'Akaun ini belum mencipta pesanan.',
    orderClosed: 'Pesanan Ditutup',
    memberOrders: 'Pesanan Ahli',
    viewDetails: 'Lihat Butiran',
    paidComplete: 'Pembayaran selesai',
    receiptFailed: 'Tidak dapat memuatkan resit.',
    invoicePdfFailed: 'Tidak dapat menjana PDF invois.',
    receiptTitle: 'Resit Pesanan',
    redirectingToOrder: 'Mengalihkan ke butiran pesanan dalam {{seconds}}s...',
    checkoutAndPay: 'Daftar Keluar dan Bayar',
    processing: 'Sedang memproses...',
    orderSummary: 'Ringkasan Pesanan',
    paymentCompleteSummary: 'Pembayaran selesai. Ini ialah ringkasan pesanan anda.',
    orderDeadlinePassed: 'Pesanan ditutup. Tarikh akhir produk telah berlalu.',
    orderCreatedMissingId: 'Pesanan telah dicipta, tetapi ID pesanan tidak ditemui. Sila semak papan pemuka anda.',
    organizationPaysSuccess: 'Pesanan bayaran organisasi berjaya dicipta. Status sudah dibayar.',
    orderCreatedRedirect: 'Pesanan berjaya dicipta. Mengalihkan ke pembayaran...',
    orderCreatedPay: 'Pesanan berjaya dicipta. Sila teruskan pembayaran.',
    cartAdded: 'Item ditambah ke troli.',
    cartPaid: 'Troli berjaya dihantar dan dibayar.',
    cartProcessed: 'Daftar keluar berjaya. Semua item diproses di bawah ID troli yang sama.',
    orderClosedShort: 'Pesanan ditutup.',
    deadline: 'Tarikh akhir: {{value}}',
    noOrderItems: 'Tiada item pesanan ditemui untuk rujukan ini.',
    backToOrders: 'Kembali ke Senarai Pesanan',
    exactNameClass: 'Masukkan nama penuh dan kelas yang tepat. Jika tiada padanan, sistem akan memaklumkan bahawa ahli tidak ditemui.',
  },
  organization: {
    workspace: 'Ruang Kerja Organisasi',
    workspaces: 'Ruang Kerja',
    settingsTitle: 'Tetapan Organisasi',
    settingsDescription: 'Pastikan profil organisasi dan butiran hubungan anda sentiasa terkini.',
    profile: 'Profil Organisasi',
    profileDescription: 'Identiti awam dan maklumat hubungan utama',
    type: 'Jenis Organisasi',
    contactPerson: 'Orang Untuk Dihubungi',
    mobileNumber: 'Nombor Telefon Bimbit',
    updated: 'Tetapan organisasi dikemas kini.',
    membersLoadFailed: 'Tidak dapat memuatkan senarai ahli.',
    dashboardLoadFailed: 'Tidak dapat memuatkan ringkasan pesanan organisasi.',
    logoUpdated: 'Logo organisasi berjaya dikemas kini.',
    logoUploadFailed: 'Tidak dapat memuat naik logo organisasi.',
    draftSaved: 'Draf berjaya disimpan. Anda boleh mengeditnya pada bila-bila masa.',
    draftSaveFailed: 'Tidak dapat menyimpan draf produk.',
    productInfoMissing: 'Sila lengkapkan maklumat produk: {{fields}}.',
    productSubmitted: 'Produk dihantar untuk kelulusan pentadbir platform.',
    productSubmitFailed: 'Tidak dapat menghantar produk untuk kelulusan.',
    submissionCancelled: 'Penghantaran dibatalkan. Produk dikembalikan kepada status draf.',
    cancelSubmissionFailed: 'Tidak dapat membatalkan penghantaran produk.',
    uploadStudentsDenied: 'Akses ditolak: anda tidak mempunyai kebenaran untuk memuat naik ahli.',
    remindersDenied: 'Akses ditolak: anda tidak mempunyai kebenaran untuk menghantar peringatan.',
    remindersSent: 'Peringatan dihantar kepada {{count}} ahli.',
    remindersFailed: 'Tidak dapat menghantar peringatan.',
    selectProductFirst: 'Sila pilih produk terlebih dahulu.',
    selectSpecificMembers: 'Sila pilih sekurang-kurangnya seorang ahli untuk mod Khusus.',
    bulkOrderSuccess: 'Pesanan pukal selesai. Dicipta: {{created}}, Dilangkau: {{skipped}}.',
    bulkOrderFailed: 'Pesanan pukal gagal.',
    uploadSuccess: 'Muat Naik Berjaya',
    productApprovedBuyerVisible: 'Produk telah diluluskan dan kini boleh dilihat oleh pembeli.',
    draftNotSubmitted: 'Draf belum dihantar kepada pentadbir platform.',
    rejectionReason: 'Sebab penolakan: {{reason}}',
    noReason: 'Tiada sebab diberikan.',
    workspaceDashboard: 'Papan Pemuka Ruang Kerja',
    workspaceMembers: 'Ahli Ruang Kerja',
    workspaceAdministrators: 'Pentadbir Ruang Kerja',
    workspaceReports: 'Laporan Ruang Kerja',
    workspaceSettings: 'Tetapan Ruang Kerja',
    currentWorkspace: 'Ruang Kerja Semasa',
    workspaceSurfaces: 'Permukaan Ruang Kerja',
    workspaceName: 'Nama Ruang Kerja',
    slug: 'Slug',
    typeLabel: 'Jenis',
    active: 'Aktif',
    workspaceLoadFailed: 'Tidak dapat memuatkan maklumat ruang kerja.',
  },
  schoolAdminDashboard: {
    activeCampaigns: 'Kempen Aktif',
    totalMembers: 'Jumlah Ahli',
    verifiedMembers: 'Ahli Disahkan',
    pendingMembers: 'Ahli Menunggu',
    ordersReceived: 'Pesanan Diterima',
    campaignCompletion: 'Penyiapan Kempen',
    productionProgress: 'Kemajuan Pengeluaran',
    packingProgress: 'Kemajuan Pembungkusan',
    deliveryProgress: 'Kemajuan Penghantaran',
    noActiveCampaigns: 'Tiada kempen aktif',
    createCampaign: 'Cipta Kempen',
    uploadRoster: 'Muat Naik Roster',
    viewDetails: 'Lihat Butiran',
    closeCampaign: 'Tutup Kempen',
    completionPercentage: '% Penyiapan',
    members: 'Ahli',
    orders: 'Pesanan',
    status: 'Status',
  },
  independent: {
    myStore: 'Kedai Saya',
    notifications: 'Notifikasi',
    seller: 'Penjual',
  },
  nav: {
    members: "Ahli",
    verification: "Pengesahan",
    myKids: 'Anak-Anak Saya',
    campaigns: 'Kempen',
    orders: 'Pesanan',
    home: 'Laman Utama',
    shop: 'Kedai',
    cart: 'Bakul',
    profile: 'Profil',
    dashboard: 'Papan Pemuka',
    rfqs: 'RFQ Terbuka',
    quotations: 'Sebutharga',
    operations: 'Operasi',
    reports: 'Laporan',
    activityLogs: 'Log Aktiviti',
    products: 'Produk',
    customers: 'Pelanggan',
    analytics: 'Analitik',
    store: 'Kedai Saya',
    settings: 'Tetapan',
    help: 'Bantuan',
    schools: 'Sekolah',
    organizations: 'Organisasi',
    vendors: 'Vendor',
    categories: 'Kategori',
    inventory: 'Inventori',
    campaignReviews: 'Semakan Kempen',
    bids: 'Tawaran',
    vouchers: 'Baucar',
    memberReports: 'Laporan Ahli',
    manageSchools: 'Urus Sekolah',
    manageOrganizations: 'Urus Organisasi',
    pendingVendors: 'Vendor Menunggu',
    finance: 'Kewangan',
    directory: 'Direktori',
  },
  platform: {
    systemSettings: 'Tetapan Sistem',
    createCategory: 'Cipta Kategori',
    updateCategory: 'Kemas Kini Kategori',
    settingsDescription: 'Urus nilai konfigurasi seluruh platform dan keterlihatan tetapan awam.',
    configurationRegistry: 'Daftar Konfigurasi',
    backDashboard: 'Kembali ke Papan Pemuka',
    settingsUpdated: 'Tetapan sistem berjaya dikemas kini.',
    settingsLoadFailed: 'Tidak dapat memuatkan tetapan sistem.',
    settingsSaveFailed: 'Tidak dapat menyimpan tetapan.',
    schoolsLoadFailed: 'Tidak dapat memuatkan organisasi.',
    vendorLoadFailed: 'Tidak dapat memuatkan vendor.',
    productsLoadFailed: 'Tidak dapat memuatkan produk.',
    profitLoadFailed: 'Tidak dapat memuatkan data keuntungan.',
    deleteSchoolFailed: 'Tidak dapat memadam organisasi.',
    adminPasswordMin: 'Kata laluan pentadbir mestilah sekurang-kurangnya 8 aksara untuk log masuk organisasi baharu.',
    schoolSavedFailed: 'Tidak dapat menyimpan organisasi.',
    noSchools: 'Tiada organisasi direkodkan lagi.',
    manageSchools: 'Urus organisasi: tambah, kemas kini, aktifkan atau nyahaktifkan tanpa memadam.',
    resetPasswordHint: 'Masukkan kata laluan baharu hanya jika anda mahu menetapkan semula log masuk organisasi. Biarkan kosong jika tiada perubahan.',
    addCategory: 'Tambah Kategori',
    allStock: 'Semua Stok',
    categoriesDescription: 'Semak taksonomi produk yang digunakan merentas katalog platform.',
    categorizedProducts: 'Produk Berkategori',
    categorizedProductsInline: 'produk berkategori',
    categoryDeleteFailed: 'Tidak dapat memadam kategori.',
    categoryDeleted: 'Kategori berjaya dipadam.',
    categoryKey: 'Kunci kategori',
    categoryKeyPlaceholder: 'Kunci (contoh: pakaian)',
    displayName: 'Nama paparan',
    editCategory: 'Edit Kategori',
    inStock: 'Dalam Stok',
    inventoryDescription: 'Urus tahap stok untuk variasi produk merentas platform menggunakan katalog produk sedia ada.',
    inventorySearchPlaceholder: 'Cari mengikut produk, sekolah, slug atau saiz',
    lowStock: 'Stok Rendah',
    noCategoriesDescription: 'Cipta atau kemas kini produk dengan kategori untuk mengisi modul ini.',
    noCategoriesYet: 'Belum ada kategori',
    noInventoryFound: 'Tiada rekod inventori ditemui',
    noInventoryFoundDescription: 'Cuba carian atau penapis stok lain.',
    outOfStock: 'Kehabisan Stok',
    paymentCenterDescription: 'Urus konfigurasi pembayaran platform dan keterlihatan tetapan.',
    saveStock: 'Simpan Stok',
    searchCategories: 'Cari kategori',
    sortOrder: 'Susunan',
    stockStatusFilter: 'Penapis status stok',
    stockValueInput: 'Input nilai stok',
    totalVariations: 'Jumlah Variasi',
    uncategorizedProducts: 'Produk Tanpa Kategori',
    variationsLabel: 'variasi',
  },
  superadmin: {
    viewAll: 'Lihat Semua',
    viewAllLowercase: 'Lihat semua',
    approve: 'Lulus',
    rejecting: 'Menolak...',
    approving: 'Meluluskan...',
    processing: 'Sedang memproses...',
    reject: 'Tolak',
    cancel: 'Batal',
    confirm: 'Sahkan',
    save: 'Simpan',
    quickActions: 'Tindakan Pantas',
    recentOrders: 'Pesanan Terkini',
    latestSchools: 'Sekolah Terkini',
    rejectOrder: 'Tolak Pesanan',
    approveOrder: 'Lulus Pesanan',
    rejectThisOrder: 'Tolak pesanan ini?',
    approveThisOrder: 'Lulus pesanan ini?',
    approveThisOrderDescription: 'Sila sahkan jika anda mahu meluluskan pesanan ini.',
    backToHome: 'Kembali ke rumah',
    invitation: 'Jemputan',
    editEmail: 'Edit E-mel',
    editAdminEmail: 'Edit E-mel Pentadbir',
    resendInvitation: 'Hantar Semula Jemputan',
    enable: 'Aktifkan',
    disable: 'Nyahaktifkan',
    suspend: 'Gantung',
    unsuspend: 'Nyahgantung',
    approvalQueue: 'Barisan Kelulusan',
    productApprovalDetails: 'Butiran Kelulusan Produk',
    reviewTrail: 'Jejak Semakan',
    manageProducts: 'Urus Produk',
    addProduct: 'Tambah Produk',
    selectSchool: 'Pilih Sekolah',
    noProducts: 'Tiada produk',
    students: 'Murid',
    orderedStudents: 'Murid Yang Memesan',
    notOrdered: 'Belum Memesan',
    parentEmail: 'E-mel Ibu Bapa',
    parentPhone: 'Telefon Ibu Bapa',
    noStudentsFound: 'Tiada murid ditemui',
    qty: 'Kty',
    payment: 'Pembayaran',
    manageSchools: 'Urus Sekolah',
    allZones: 'Semua Zon',
    schoolLevelPrimary: 'Rendah',
    schoolLevelSecondary: 'Menengah',
    slug: 'Slug',
    schoolCode: 'Kod Sekolah',
    zone: 'Zon',
    area: 'Kawasan',
    phoneNumber: 'Nombor Telefon',
    bulkImport: 'Import Pukal Sekolah KL',
    importSchools: 'Import Sekolah',
    importReadyData: 'Import 40 Sekolah Sedia',
    importReadyDescription: 'Import automatik tanpa memuat naik fail.',
    filterSchool: 'Tapis Sekolah',
    editSchool: 'Edit Sekolah',
    addNewSchool: 'Tambah Sekolah Baharu',
    schoolList: 'Senarai Sekolah',
    schoolsCount: '{{count}} sekolah',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    reset: 'Tetap Semula',
    updateSchool: 'Kemas Kini Sekolah',
    saveSchool: 'Simpan Sekolah',
    deleteSchool: 'Padam Sekolah',
    deleteSchoolConfirmation: 'Padam sekolah ini? Tindakan ini tidak boleh dibuat asal.',
    noPendingApprovals: 'Tiada kelulusan menunggu',
    noPendingApprovalsDescription: 'Tiada produk menunggu semakan sekarang.',
    viewInventory: 'Lihat Inventori',
    schoolsRegistered: 'Sekolah didaftarkan',
    ordersRecorded: 'Pesanan direkodkan',
    platformUsers: 'Pengguna platform',
    paidRevenue: 'Hasil dibayar',
    awaitingReview: 'Menunggu semakan',
    pendingApprovalsTitle: 'Kelulusan Menunggu',
    todaysActivity: 'Aktiviti Hari Ini',
    addOrganization: 'Tambah Organisasi',
    pendingVendors: 'Vendor Menunggu',
    bidsManagement: 'Pengurusan Tawaran',
    printLabels: 'Cetak Label',
    totalSchools: 'Jumlah Sekolah',
    totalOrders: 'Jumlah Pesanan',
    totalRevenue: 'Jumlah Hasil',
    totalUsers: 'Jumlah Pengguna',
    pendingApprovalsCount: 'Kelulusan Menunggu',
    goodEvening: 'Selamat petang, Pentadbir Super',
    dashboardSubtitle: 'Urus platform Cheeco',
    dashboardDescription: 'Pantau sekolah, pesanan, vendor dan aktiviti platform dalam masa nyata.',
    reason: 'Sebab',
    noAdmin: 'Tiada pentadbir',
    pendingActivation: 'Menunggu Pengaktifan',
    invitationSent: 'Jemputan Dihantar',
    expired: 'Tamat Tempoh',
    unknown: 'Tidak Diketahui',
    noOrganizationsFound: 'Tiada organisasi ditemui',
    noOrganizationsDescription: 'Tiada organisasi dalam status ini.',
    organizationStatusUpdated: 'Status organisasi dikemas kini.',
    invitationRegenerated: 'Jemputan dijana semula dan dihantar.',
    resetAdminPassword: 'Tetap semula kata laluan pentadbir? Jemputan baharu akan dihantar.',
    passwordReset: 'Kata laluan ditetap semula. Jemputan baharu dihantar.',
    adminEmailUpdated: 'E-mel pentadbir dikemas kini.',
    schoolDeleted: 'Sekolah berjaya dipadam.',
    importCompleted: 'Import selesai: {{count}} sekolah berjaya diimport.',
    readyDataImported: 'Data sedia diimport: {{count}} sekolah diproses.',
    importFileRequired: 'Sila pilih fail import (.xlsx atau .csv).',
    adminPasswordMin: 'Kata laluan pentadbir lalai mestilah sekurang-kurangnya 8 aksara.',
    selectImportFile: 'Pilih sekolah daripada senarai sedia (pilihan)',
    category: 'Kategori',
    domainOptional: 'Domain (pilihan)',
    resetAdminPasswordPlaceholder: 'Tetap Semula Kata Laluan Pentadbir (pilihan)',
    adminPasswordPlaceholder: 'Kata Laluan Pentadbir',
    loadingDashboard: 'Memuatkan papan pemuka...',
    loadingApprovals: 'Memuatkan kelulusan...',
    unableToLoadSchools: 'Tidak dapat memuatkan sekolah.',
    unableToLoadOrganizations: 'Tidak dapat memuatkan organisasi.',
    unableToLoadPendingApprovals: 'Tidak dapat memuatkan kelulusan menunggu.',
    sent: 'Dihantar',
    disableOrganization: 'Organisasi ini akan kehilangan akses ke papan pemuka.',
    suspendOrganization: 'Organisasi ini akan digantung serta-merta.',
    rejectOrganization: 'Organisasi ini akan ditolak dan dinyahaktifkan.',
    approveOrganization: 'Organisasi ini akan diaktifkan dan e-mel jemputan akan dihantar kepada pentadbir.',
    noPendingOrders: 'Tiada pesanan menunggu kelulusan.',
    orderList: 'Senarai Pesanan',
    ordersCount: '{{count}} pesanan',
    noOrdersFound: 'Tiada pesanan ditemui',
    noOrdersDescription: 'Tiada pesanan direkodkan lagi.',
    details: 'Butiran',
    harga: 'Harga',
    hargaJualan: 'Harga Jualan',
    kosAsas: 'Kos Asas',
    deadline: 'Tarikh Akhir',
    submitted: 'Dihantar',
    front: 'Hadapan',
    back: 'Belakang',
    logo: 'Logo',
    noImage: 'Tiada imej',
    schoolInformation: 'Maklumat Sekolah',
    school: 'Sekolah',
    contact: 'Orang Untuk Dihubungi',
    email: 'E-mel',
    phone: 'Telefon',
    status: 'Status',
    reviewedAt: 'Disemak Pada',
    reviewedBy: 'Disemak Oleh',
    reviewerEmail: 'E-mel Penyemak',
    noAdditionalDescription: 'Tiada keterangan tambahan.',
    variations: 'Variasi',
    stock: 'Stok',
    rejectionReason: 'Sebab Penolakan',
    loadingProductApprovalDetails: 'Memuatkan butiran kelulusan produk...',
    productNotFound: 'Produk tidak ditemui.',
    allSchoolProductsWaiting: 'Semua produk sekolah menunggu semakan',
    pendingCount: 'Bilangan Menunggu',
    noPendingProductsReview: 'Tiada produk menunggu untuk disemak sekarang.',
    orderApprovalQueue: 'Barisan Kelulusan Pesanan',
    pendingApproval: 'Menunggu Kelulusan',
    defaultAdminPassword: 'Kata laluan pentadbir lalai',
    searchNameSlugArea: 'Cari nama/slug/kawasan',
    superAdmin: 'Pentadbir Super',
    loginDescription: 'Log masuk ke portal tadbir urus platform.',
    operationsCenter: 'Pusat Operasi',
    governanceDashboard: 'Papan Pemuka Tadbir Urus',
    governanceSubtitle: 'Kesihatan platform, eskalasi, dan pemantauan rentas penyewa',
    operationsCenterSubtitle: 'Apa yang memerlukan perhatian anda hari ini',
    attentionRequired: 'Perhatian Diperlukan',
    pendingProductsApproval: 'Produk menunggu kelulusan',
    pendingStoreUpdates: 'Kemas kini kedai menunggu semakan',
    pendingOrganizations: 'Organisasi menunggu persediaan',
    noAttentionRequired: 'Tiada yang memerlukan perhatian anda sekarang.',
    platformHealth: 'Kesihatan Platform',
    everythingLooksNormal: 'Semuanya kelihatan normal',
    viewDetailedReports: 'Lihat Laporan Terperinci',
    recentActivity: 'Aktiviti Terkini',
    viewFullActivityLog: 'Lihat Log Aktiviti Penuh',
    registered: 'didaftarkan',
    order: 'Pesanan',
    from: 'daripada',
    reviewAll: 'Semak Semua',
    productsActive: 'Produk Aktif',
    failedPayments: 'Pembayaran Gagal',
    expiredInvitations: 'Jemputan Tamat Tempoh',
    operationsQueue: 'Barisan Operasi',
    noOperationsQueue: 'Tiada dalam barisan sekarang.',
    viewOperationsCenter: 'Lihat Pusat Operasi',
    activate: 'Aktifkan',
    addPlatformAdmin: 'Tambah Pentadbir Platform',
    addStaff: 'Tambah Staf',
    adminContact: 'Pentadbir / Hubungan',
    adminEmailPlaceholder: 'E-mel pentadbir',
    create: 'Cipta',
    createStaff: 'Cipta Staf',
    custom: 'Khusus',
    deactivate: 'Nyahaktifkan',
    department: 'Jabatan',
    disabled: 'Dinyahaktif',
    editStaff: 'Edit Staf',
    invitationReset: 'Jemputan berjaya ditetapkan semula.',
    jobTitle: 'Jawatan',
    loadingActivity: 'Memuatkan aktiviti...',
    loadingStaff: 'Memuatkan staf...',
    manageOrganizationsDescription: 'Urus status organisasi, jemputan dan akaun pentadbir.',
    manageUsers: 'Urus Pengguna',
    manageUsersSubtitle: 'Cipta pentadbir platform dan kawal akses akaun.',
    newPassword: 'Kata laluan baharu',
    noActivity: 'Tiada aktiviti',
    noActivityDescription: 'Tiada log aktiviti ditemui untuk staf ini.',
    noStaffDescription: 'Belum ada ahli staf. Cipta satu untuk bermula.',
    noStaffFound: 'Tiada staf ditemui',
    noUsersDescription: 'Belum ada pengguna platform.',
    noUsersFound: 'Tiada pengguna ditemui',
    permissions: 'Kebenaran',
    resetPassword: 'Tetap Semula Kata Laluan',
    setNewPassword: 'Tetapkan kata laluan baharu untuk',
    staffActivity: 'Aktiviti Staf',
    staffCreated: 'Staf berjaya dicipta.',
    staffDisabled: 'Staf dinyahaktifkan.',
    staffEnabled: 'Staf diaktifkan.',
    staffManagement: 'Pengurusan Staf',
    staffManagementDescription: 'Cipta, urus dan pantau staf platform dalaman.',
    staffUpdated: 'Staf berjaya dikemas kini.',
    superAdminAccount: 'Akaun Pentadbir Super',
    thisUser: 'pengguna ini',
    unableToLoadActivity: 'Tidak dapat memuatkan log aktiviti.',
    unableToLoadDashboard: 'Tidak dapat memuatkan papan pemuka.',
    unableToLoadStaff: 'Tidak dapat memuatkan staf pada masa ini.',
    unableToResetInvitation: 'Tidak dapat menetapkan semula jemputan.',
    unableToSaveStaff: 'Tidak dapat menyimpan staf. Sila cuba lagi.',
    unableToUpdateStatus: 'Tidak dapat mengemas kini status.',
    usersCount: '{{count}} pengguna',
    yourPassword: 'Kata laluan anda',
  },
  email: {
    resetTitle: 'Tetapkan Semula Kata Laluan',
    resetIntro: 'Kami menerima permintaan untuk menetapkan semula kata laluan akaun Cheeco anda.',
    resetTenantIntro: 'Kami menerima permintaan untuk menetapkan semula kata laluan bagi {{tenant}}.',
    resetInstruction: 'Klik butang di bawah untuk menetapkan kata laluan baharu. Pautan ini sah selama {{minutes}} minit.',
    resetButton: 'Tetapkan Semula Kata Laluan',
    fallbackLink: 'Jika butang tidak berfungsi, gunakan pautan ini:',
    ignoreReset: 'Jika anda tidak meminta perkara ini, anda boleh abaikan e-mel ini.',
  },
  membership: {
    title: 'Pengesahan Sekolah',
    statusMember: 'Disahkan',
    statusPending: 'Menunggu Pengesahan',
    statusException: 'Dalam Semakan',
    verifiedMessage: 'Anda kini boleh menyertai kempen dan membuat pesanan.',
    pendingMessage: 'Pengesahan tidak dapat diselesaikan. Permintaan anda telah dihantar untuk semakan.',
    submitClaim: 'Hantar Pengesahan',
    childName: 'Nama Anak',
    childClass: 'Kelas Anak',
    childHouse: 'Rumah Sukan Anak',
    pendingQueue: 'Pengesahan Menunggu',
    confirmMember: 'Sahkan Keahlian',
    markException: 'Tanda sebagai Pengecualian',
    escalatedCases: 'Kes Pengecualian',
    settings: 'Tetapan Pengesahan',
    autoEscalationHours: 'Penaikan Auto (Jam)',
    sportsHouseRequired: 'Rumah Sukan Diperlukan',
    allowManualOverride: 'Benarkan Lulus Manual',
    membershipRequired: 'Keahlian Diperlukan',
    campaignGate: 'Pagar Kempen Diaktifkan',
    lockedCampaign: 'Lengkapkan pengesahan sekolah untuk menyertai kempen ini.',
    myMemberships: 'Keahlian Saya',
  },
  onboarding: {
    minCharacters: 'Sila masukkan sekurang-kurangnya 2 aksara',
    noSchoolsFoundTerm: 'Tiada sekolah ditemui. Cuba istilah carian lain.',
    searchFailed: 'Carian gagal. Sila cuba lagi.',
    enterName: 'Sila masukkan nama anda',
    nameMinCharacters: 'Nama mestilah sekurang-kurangnya 2 aksara',
    enterSchoolName: 'Sila masukkan nama sekolah',
    selectSchool: 'Sila pilih sekolah',
    setupFailed: 'Gagal menyiapkan persediaan. Sila cuba lagi.',
    schoolStaff: 'Staf Sekolah',
    createOrJoin: 'Cipta sekolah baharu atau sertai sekolah sedia ada',
    joinYourChild: 'Sertai sekolah anak anda menggunakan pautan jemputan atau Kod QR',
    yourName: 'Nama Anda',
    joinAs: 'Sertai Sebagai',
    setup: 'Persediaan',
    step: 'Langkah pendaftaran',
    progress: 'Kemajuan pendaftaran',
    welcome: 'Selamat Datang ke Cheeco!',
    whatIsYourName: 'Apakah nama anda?',
    yourFullName: 'Nama penuh anda',
    iAmJoiningAs: 'Saya menyertai sebagai...',
    selectHowJoining: 'Pilih cara anda menyertai',
    howWouldYouLike: 'Bagaimana anda mahu meneruskan?',
    createNewSchool: 'Cipta Sekolah Baharu',
    setupSchoolProfile: 'Sediakan profil sekolah anda dan mula mengurus kempen',
    joinExistingSchool: 'Sertai Sekolah Sedia Ada',
    searchForSchool: 'Cari sekolah anda dan minta untuk menyertai',
    schoolNameExample: 'cth., SMK Bukit Jalil',
    youWillBecomeAdmin: 'Anda akan menjadi Pentadbir Sekolah dan boleh mengurus kempen, ahli dan tetapan.',
    settingUp: 'Sedang menyediakan...',
    createSchoolAndContinue: 'Cipta Sekolah & Teruskan',
    findYourSchool: 'Cari Sekolah Anda',
    searchBySchoolName: 'Cari mengikut nama sekolah atau kod sekolah. Permintaan anda akan dihantar kepada Pemilik Sekolah untuk kelulusan.',
    searchByNameOrCode: 'Cari mengikut nama atau kod sekolah',
    searching: 'Sedang mencari...',
    selected: 'Dipilih:',
    statusAfterSetup: 'Status selepas persediaan:',
    requestToJoinSchool: 'Minta untuk Menyertai Sekolah',
    parentAccess: 'Akses Ibu Bapa',
    parentsOfficialInvitations: 'Ibu bapa menyertai sekolah melalui jemputan rasmi sahaja.',
    howToJoin: 'Cara menyertai:',
    openInvitationLink: 'Buka pautan jemputan daripada sekolah anda',
    scanQRCode: 'Imbas Kod QR yang disediakan oleh sekolah',
    enterInvitationCode: 'Masukkan kod jemputan',
    contactAdmin: 'Hubungi pentadbir sekolah anda jika anda memerlukan jemputan.',
    continueAsParent: 'Teruskan sebagai Ibu Bapa',
  },
  schoolSetup: {
    imageTypesAllowed: 'Hanya imej PNG, JPG, atau WebP dibenarkan.',
    logoSizeLimit: 'Logo mestilah lebih kecil daripada 2 MB.',
    schoolNameRequired: 'Nama Sekolah diperlukan.',
    schoolAddressRequired: 'Alamat Sekolah diperlukan.',
    stateRequired: 'Negeri diperlukan.',
    contactNumberRequired: 'Nombor Hubungan diperlukan.',
    profileSavedRefreshing: 'Profil sekolah berjaya disimpan. Sedang memuat semula...',
    profileSaved: 'Profil sekolah disimpan.',
    unableToSaveProfile: 'Tidak dapat menyimpan profil sekolah.',
    unableToCompleteSetup: 'Tidak dapat menyiapkan persediaan.',
    completeProfile: 'Lengkapkan Profil Sekolah',
    required: 'Wajib',
    createFirstCampaign: 'Cipta Kempen Pertama Anda',
    inviteSchoolMembers: 'Jemput Ahli Sekolah',
    optional: 'Pilihan',
    title: 'Persediaan Sekolah',
    completeProfileDescription: 'Lengkapkan profil sekolah anda untuk membuka kunci platform penuh. Ini mengambil masa kurang daripada 2 minit.',
    completeProfileDescriptionShort: 'Lengkapkan profil sekolah anda untuk membuka kunci papan pemuka sekolah anda.',
    completed: 'Selesai',
    profile: 'Profil Sekolah',
    identityDescription: 'Ini menjadi identiti anda merentas semua kempen dan laporan.',
    logo: 'Logo Sekolah',
    changeLogo: 'Tukar logo',
    uploadLogo: 'Muat naik logo sekolah',
    logoFormatHint: 'PNG, JPG atau WebP. Maks 2 MB.',
    schoolName: 'Nama Sekolah',
    schoolNamePlaceholder: 'cth. SMK Putra Impian',
    schoolAddress: 'Alamat Sekolah',
    addressPlaceholder: 'Alamat penuh termasuk poskod',
    state: 'Negeri',
    statePlaceholder: 'cth. Selangor',
    contactNumber: 'Nombor Hubungan',
    contactNumberPlaceholder: 'cth. +60 12-345 6789',
    saveAndContinue: 'Simpan & Teruskan',
    profileComplete: 'Profil sekolah lengkap!',
    identityActive: 'Identiti sekolah anda kini aktif merentas platform.',
    startOrderDescription: 'Mulakan pesanan baju atau uniform untuk sekolah anda.',
    optionalStaffDescription: 'Pilihan — tambah guru dan wakil kelas.',
  },
  pendingAccess: {
    title: 'Akses Sekolah Menunggu',
    yourRequestToJoin: 'Permintaan anda untuk menyertai',
    waitingApproval: 'sedang menunggu kelulusan daripada Pemilik Sekolah.',
    notificationInfo: 'Anda akan menerima notifikasi sebaik sahaja Pemilik Sekolah meluluskan permintaan anda. Ini biasanya mengambil masa 1-2 hari bekerja.',
    schoolCode: 'Kod Sekolah:',
    logOut: 'Log Keluar',
  },
  joinSchool: {
    searchPlaceholder: 'Cari mengikut nama, kod sekolah, atau lokasi',
    searchPlaceholderExample: 'cth., SMK Bukit Jalil atau CHC-12345',
    noSchoolsFound: 'Tiada sekolah ditemui. Cuba carian lain.',
    join: 'Sertai',
    backToSignIn: 'Kembali ke Log Masuk',
  },
  notifications: {
    unreadCount: 'Notifikasi: {{count}} belum dibaca',
    markRead: "Dibaca",
    archive: "Arkib",
    saving: "Menyimpan...",
    timelineEvent: "Acara garis masa",
    title: 'Notifikasi',
    menu: 'Menu notifikasi',
    markAllRead: 'Tanda semua telah dibaca',
    empty: 'Belum ada notifikasi',
    clickToView: 'Klik untuk melihat →',
    unread: 'Belum dibaca',
  },
  dashboard: {
    finishSchoolSetup: 'Siapkan persediaan sekolah anda',
    quickSetupSteps: 'Lengkapkan langkah persediaan pantas untuk membuka kunci papan pemuka sekolah anda.',
    goToSetup: 'Ke Persediaan',
    loadingData: 'Memuatkan data papan pemuka...',
  },
  parentOrder: {
    portalTitle: 'Portal Ibu Bapa',
    dashboard: 'Papan Pemuka',
    productImage: 'Imej Produk',
    previewImage: 'Pratonton imej produk',
    closePreview: 'Tutup pratonton imej',
    priceDeadline: 'Harga + Tarikh Tutup',
    productDetails: 'Butiran Produk',
    sleeveTypeLabel: 'Jenis Lengan: Lengan Pendek, Lengan Panjang',
    campaignPayment: 'Kempen / Pembayaran',
    selectCampaign: 'Pilih Kempen',
    defaultNoCampaign: 'Lalai (tiada kempen)',
    sportsHouse: 'Rumah Sukan / Pasukan',
    sleeve: 'Lengan',
    size: 'Saiz',
    quantity: 'Kuantiti',
    total: 'Jumlah',
    shortSleeve: 'Lengan Pendek',
    longSleeve: 'Lengan Panjang',
    noItemsFound: 'Tiada item pesanan ditemui untuk rujukan ini.',
    orderNumber: 'Nombor Pesanan',
    selectSportsHouse: 'Pilih Rumah Sukan',
    orEnterManually: 'atau masukkan secara manual',
    paymentMethod: 'Kaedah Pembayaran',
    voucherCode: 'Kod Voucher',
    enterVoucherCode: 'Masukkan kod voucher',
    addToCart: 'Tambah ke Troli',
    orderClosed: 'Pesanan Ditutup',
    sizeChart: 'Carta Saiz',
    sizeChartNotSet: 'Carta saiz belum ditetapkan.',
    sizeChartPlaceholder: 'Ukuran / nota size chart',
    measurement: 'Ukuran',
    unitPrice: 'Harga Seunit',
    itemTotal: 'Jumlah Item',
    orderSuccess: 'Pesanan berjaya dibuat. Sila teruskan dengan pembayaran.',
    orderRecorded: 'Pesanan direkodkan. Menunggu pembayaran atau kelulusan.',
    totalAmount: 'Jumlah: {{amount}}',
    back: 'Kembali',
    editOrders: 'Sunting Pesanan',
    orderLabel: 'Pesanan',
    orderIdLabel: 'Pesanan #{{number}}',
    fullNameClassHint: 'Masukkan nama penuh dan kelas yang tepat. Jika tiada padanan, sistem akan memaklumkan bahawa murid tidak ditemui.',
    save: 'Simpan',
    receiptTitle: 'Resit — Pesanan',
    orderList: 'Senarai Pesanan',
    viewOrderDetails: 'Lihat Butiran Pesanan',
    paymentSource: 'Sumber Pembayaran',
    parentPayment: 'Pembayaran Ibu Bapa',
    redirectingToOrder: 'Dialihkan ke butiran pesanan dalam {{count}}s...',
    paymentCompleted: 'Pembayaran selesai. Pesanan telah direkodkan.',
    memberName: 'Nama {{member}}',
    orderForm: 'Borang Pesanan',
    cart: 'Troli',
    viewCurrentOrder: 'Lihat Pesanan Semasa',
    viewCart: 'Lihat Troli',
    saving: 'Menyimpan...',
    saveChanges: 'Simpan Perubahan',
    saveAndCheckout: 'Simpan & Checkout',
    memberItem: 'Item {{member}} #{{index}}',
    orderId: 'ID Pesanan',
    backToOrderList: 'Kembali ke Senarai Pesanan',
    ended: 'Tamat',
    endedClosed: 'Tamat! / Ditutup',
    reviewBeforeOrder: "Semak butiran pelajar dan saiz sebelum membuat pesanan.",
    fullNameClassHintDynamic: 'Masukkan nama penuh dan {{group}} yang tepat. Jika tiada padanan, sistem akan memaklumkan bahawa {{member}} tidak ditemui.',
    totalLabel: 'JUMLAH',
    backToDashboard: 'Kembali ke Papan Pemuka',
    product: 'Produk',
    productAndOrganization: 'Produk dan {{organization}}',
    fundingCodeRequired: 'Kod pembiayaan diperlukan untuk kempen ini.',
    orderWindowClosed: 'Pesanan ditutup. Tarikh akhir produk ini telah tamat.',
    orderRedirecting: 'Pesanan berjaya dibuat. Mengalihkan ke pembayaran...',
    itemAddedToCart: 'Item ditambah ke troli.',
    sportsHousePlaceholder: 'Rumah Sukan / Pasukan',
    sportsHouseOptional: 'Rumah Sukan / Pasukan (pilihan)',
    hi: "Hai, {{name}} 👋",
    familyNextStep: "Inilah yang perlu dilakukan seterusnya untuk keluarga anda.",
    orderNow: "Pesan Sekarang",
    browseAll: "Lihat semua",
    openLabel: "Buka:",
    closeLabel: "Tutup:",
    productCount: "{{count}} Produk",
    recentOrders: "Pesanan Terkini",
    viewAll2: "Lihat semua",
    track: "Jejak",
    myCampaigns: "Kempen Saya",
    browseCampaigns: "Lihat kempen aktif merentas kumpulan yang anda sertai",
    browseCampaignsDesc: "Jejaki kempen terbuka, lihat produk yang ditetapkan, dan teruskan terus ke pesanan untuk organisasi yang dipautkan ke akaun anda.",
    kpiTotal: "Jumlah",
    kpiActive: "Aktif",
    kpiClosed: "Ditutup",
    viewOrders: "Lihat Pesanan",
    studentsCount: "Pelajar ({{count}})",
    availableProducts: "Produk Tersedia",
    checkout: "Daftar Keluar",
    checkoutMulti: "Daftar Keluar Berbilang Kumpulan",
    checkoutDesc: "Semak item anda dan lengkapkan pembelian anda.",
    checkoutMultiDesc: "Urus produk daripada pelbagai kumpulan dan lengkapkan segala-galanya dalam satu daftar keluar yang selamat.",
    continueShopping: "Teruskan Membeli-belah",
    emptyCart: "Bakul anda kosong",
    emptyCartDesc: "Lihat kempen yang tersedia dan tambah item ke bakul anda.",
    browseCampaignsBtn: "Lihat Kempen",
    checkoutSuccess: "Daftar keluar berjaya. Semua item diproses di bawah ID bakul yang sama.",
    studentCount: "{{count}} Pelajar",
    addStudent: "Tambah Pelajar",
    classLabel2: "Kelas",
    optionsAria: "Pilihan",
    noStudentsLinked: "Tiada pelajar dipautkan ke sekolah ini lagi.",
    pmOnlinePayment: "Pembayaran Dalam Talian",
    pmVoucher: "Kod Baucar",
    pmQrVoucher: "Baucar QR",
    pmManualTransfer: "Pindahan Bank Manual",
    manualPaymentSelected: "Pembayaran manual dipilih. Pesanan akan dihantar untuk kelulusan sebelum pembayaran disahkan.",
    qrVoucherCode: "Kod Baucar QR",
    timeDays: "{{n}} hari",
    timeHours: "{{n}} jam",
    timeMinutes: "{{n}} min",
    productCode: "Kod: {{value}}",
    productMaterial: "Bahan: {{value}}",
    productWeight: "Berat: {{value}}",
    shortSleevePrice: "Harga Lengan Pendek: {{value}}",
    longSleevePrice: "Harga Lengan Panjang: {{value}}",
    colorsLabel: "Warna: {{value}}",
    deadlineLabel: "Tarikh Tutup: {{value}}",
    ordersClosed: "Pesanan ditutup.",
    sportsHouseRequired: "Sila pilih rumah sukan untuk setiap {{member}}.",
    addMemberAction: "+ Tambah {{member}}",
    addMemberGroup: "+ Tambah {{member}} / {{group}}",

    // ParentOrders page
    ordersTitle: "Pesanan",
    ordersSubtitle: "Jejak dan bayar pesanan anda.",
    filterAll: "Semua",
    filterToPay: "Belum Dibayar",
    filterPaid: "Dibayar",
    loadingOrders: "Memuatkan pesanan anda…",
    nothingToPay: "Tiada apa yang perlu dibayar",
    noPaidOrders: "Tiada pesanan dibayar",
    noOrdersYet: "Tiada pesanan lagi",
    ordersEmptyDesc: "Pesanan yang anda buat akan muncul di sini dengan status terkini.",
    tryDifferentFilter: "Cuba penapis lain untuk melihat lebih banyak pesanan.",
    paying: "Membayar...",
    payBtn: "Bayar",
    unableToLoadOrders: "Tidak dapat memuatkan pesanan anda.",
    unableToInitPayment: "Tidak dapat memulakan pembayaran dalam talian.",
    // ParentHome
    homeUnableToLoad: "Tidak dapat memuatkan laman utama anda.",
    homeNoActiveCampaigns: "Tiada kempen aktif",
    homeNoProductsYet: "Tiada produk tersedia lagi",
    homeNoProductsDesc: "Kempen baharu akan muncul di sini sebaik sahaja sekolah anda menerbitkannya.",
    homeNoProductsDesc2: "Sekolah anda telah menerbitkan kempen tetapi belum menambah produk. Semak semula tidak lama lagi!",
    // ParentCampaigns
    unableToLoadCampaigns: "Tidak dapat memuatkan kempen anda.",
    loadingCampaigns: "Memuatkan kempen...",
    noCampaignsAvailable: "Tiada kempen tersedia",
    noCampaignsAvailableDesc: "Organisasi yang anda pautkan belum mempunyai sebarang kempen aktif atau ditutup.",
    // ParentCart
    orderCreatedPayment: "Pesanan dibuat. Meneruskan ke pembayaran...",
    unableToInitPaymentRetry: "Tidak dapat memulakan pembayaran dalam talian. Anda boleh cuba semula dari halaman resit.",
    orderCreatedComplete: "Pesanan dibuat. Selesaikan pembayaran dari halaman resit.",
    cartSubmitted: "Bakul dihantar dengan jayanya.",
    unableToCheckoutCart: "Tidak dapat menyemak keluar bakul.",
    removeItemAria: "Buang item",
    // ParentReceipt
    unableToLoadReceipt: "Tidak dapat memuatkan resit.",
    loadingReceipt: "Memuatkan resit...",
    paymentCompletedSummary: "Pembayaran selesai. Ini adalah ringkasan pesanan anda.",
    unableToFindOrgPaymentLink: "Tidak dapat mencari pautan pembayaran organisasi untuk pesanan ini.",
    unableToStartOnlinePayment: "Tidak dapat memulakan pembayaran dalam talian.",
    unableToGeneratePdf: "Tidak dapat menjana PDF invois.",
    // ParentOrder / ParentOrderEdit
    unableToLoadProducts: "Tidak dapat memuatkan produk.",
    unableToLoadChildData: "Tidak dapat memuatkan data anak.",
    unableToLoadOrderItems: "Tidak dapat memuatkan item pesanan.",
    orderNotFound: "Pesanan dibuat, tetapi ID pesanan tidak ditemui. Sila semak papan pemuka anda.",
    loadingOrderForm: "Memuatkan borang pesanan...",
    exampleOrderNo: "cth. ABC-2027",
    selectSavedMember: "Pilih {{member}} tersimpan (pilihan)",
    lookingUpRecords: "Menyemak rekod sekolah untuk {{name}}...",
    thisMember: "ahli ini",
    unableToLoadOrder: "Tidak dapat memuatkan pesanan.",
    // ParentCartReceipt
    loadingCartReceipt: "Memuatkan resit bakul...",
    unableToLoadCartReceipt: "Tidak dapat memuatkan resit bakul.",
    paymentOrderSummary: "Ringkasan Pembayaran / Pesanan",
    cartReceiptTitle: "Resit bakul",
    onePaymentAllSchools: "Satu pembayaran untuk semua sekolah",
    checkoutComplete: "Daftar keluar selesai",
    aggregateCartDesc: "Semua pesanan dalam bakul anda dilindungi oleh satu pembayaran.",
    allOrdersProcessed: "Semua pesanan dalam bakul ini diproses bersama.",
    backToCart: "Kembali ke bakul",
    cartIdLabel: "ID Bakul",
    overallTotal: "Jumlah keseluruhan",
    paidBy: "Dibayar Oleh",
    groupsInCart: "Kumpulan dalam bakul ini",
    groupsInCartDesc: "Pesanan dikumpulkan mengikut kumpulan untuk semakan yang lebih mudah.",
    orderColon: "Pesanan: {{number}}",
    orderCount: "{{count}} pesanan",
    orgTotal: "Jumlah {{organization}}",
    sizeLabel: "Saiz {{size}}",
    unitCount: "{{count}} unit",
    paymentRequired: "Pembayaran diperlukan",
    completeOnlinePayment: "Lengkapkan pembayaran dalam talian anda",
    pendingPaymentDesc: "Pesanan anda telah dibuat tetapi pembayaran masih belum selesai. Klik Bayar Sekarang untuk meneruskan ke gerbang pembayaran.",
    initializingPayment: "Memulakan pembayaran...",
    payNowBtn: "Bayar Sekarang",
    nextStep: "Langkah seterusnya",
    continueBrowsingOrDashboard: "Teruskan melayari atau kembali ke papan pemuka",
    cartCompleteDesc: "Bakul ini lengkap. Anda boleh kembali ke papan pemuka untuk menambah bakul lain.",
    openCart: "Buka bakul",
    paymentGatewayError: "Gerbang pembayaran tidak mengembalikan URL pembayaran. Sila cuba lagi atau hubungi sokongan.",
    unableToInitOnlinePayment: "Tidak dapat memulakan pembayaran dalam talian. Sila cuba lagi.",
    pmOrgSponsored: "Ditaja Organisasi",
    pmManual: "Pembayaran Manual",
    pmCash: "Tunai",
    pmBankTransfer: "Pindahan Bank",
    pmCheque: "Cek",
    pmComplimentary: "Percuma / FOC",
    psParent: "Ibu Bapa",
    psOrganization: "Organisasi",
    psManual: "Manual",
    psComplimentary: "Percuma",
    // TaskList
    goodMorning: "Selamat Pagi",
    goodAfternoon: "Selamat Tengah Hari",
    goodEvening: "Selamat Petang",
    taskOpen: "Buka",
    taskClosed: "Tutup",
    daysLeftOne: "{{days}} hari lagi",
    daysLeftMany: "{{days}} hari lagi",
    activeTasks: "Tugas Aktif",
    pendingOrders: "Pesanan Belum Selesai",

  },
  messages: {
    saveSuccess: 'Rekod berjaya disimpan.',
    updateSuccess: 'Perubahan berjaya dikemas kini.',
    requiredWarning: 'Sila lengkapkan semua medan wajib.',
    saveError: 'Tidak dapat menyimpan rekod. Sila cuba lagi.',
    csvImportInfo: 'Import CSV berjaya diselesaikan.',
    loadNotificationsError: 'Tidak dapat memuatkan notifikasi. Sila cuba lagi.',
    updateNotificationError: 'Tidak dapat mengemas kini notifikasi. Sila cuba lagi.',
    markAllError: 'Tidak dapat menandakan semua notifikasi. Sila cuba lagi.',
    archiveError: 'Tidak dapat mengarkibkan notifikasi. Sila cuba lagi.',
    updateSettingsError: 'Tidak dapat mengemas kini tetapan notifikasi. Sila cuba lagi.',
    loadInvoiceError: 'Tidak dapat memuatkan invois. Sila cuba lagi.',
    loadInvoicePdfError: 'Tidak dapat memuatkan PDF invois. Sila cuba lagi.',
  },
  rejectOrder: {
    title: 'Tolak Pesanan',
    provideReason: 'Sila berikan sebab',
    reason: "Sebab",
    reasonRequired: "Sebab diperlukan.",
  },
  funding: {
    addSourceHint: 'Tambah sumber pembiayaan untuk kempen ini supaya pesanan boleh ditaja atau dibiayai oleh pihak ketiga.',
    addFirstSource: 'Tambah Sumber Pertama',
    editSourceAria: 'Kemaskini sumber pembiayaan',
    deleteSourceAria: 'Padam sumber pembiayaan',
    usageDescription: 'Pesanan yang menggunakan sumber pembiayaan ini akan dipaparkan di sini.',
  },  org: {
    adminsTitle: "Pentadbir Organisasi",
    noMembersImported: "Tiada ahli diimport lagi.",
    addLogo: "Tambah Logo",
    uploadLogo: "Muat Naik Logo",
    dismiss: "Tutup",
    payoutAccounts: "Akaun Pembayaran",
    clickToUploadLogo: "Klik untuk muat naik logo",
    orgTypeSchool: "Sekolah",
    orgTypeClub: "Kelab",
    orgTypeAssociation: "Persatuan",
    orgTypeNgo: "NGO",
    orgTypeCommunity: "Komuniti",
    orgTypeCompany: "Syarikat",
    malaysianBank: "Akaun Bank Malaysia",
    paypal: "Akaun PayPal",
    noPayouts: "Tiada Akaun Pembayaran Ditambah",
    deletePayout: "Padam Akaun Pembayaran",
    noSpacesDashes: "Tiada ruang atau sempang",
    idNric: "NRIC / MyKad",
    idPassport: "Pasport",
    idBrn: "Pendaftaran Perniagaan (BRN)",
    currencyMyr: "Ringgit Malaysia (RM)",
    currencyUsd: "Dolar AS (USD)",
    currencySgd: "Dolar Singapura (SGD)",
    autofillPh: "Biarkan kosong untuk auto-isi",
    accountEmailPh: "account@domain.com",
    dashDesc: "Urus kempen, ahli, pesanan dan laporan organisasi anda.",
    loadingMetrics: "Memuatkan metrik ruang kerja...",
    noCampaigns: "Tiada kempen dicipta lagi.",
    createFirstCampaign: "Cipta kempen pertama anda untuk mula menerima pesanan ahli.",
    noOrders: "Tiada pesanan dibuat lagi.",
    ordersHint: "Pesanan akan muncul di sini apabila ahli membeli dari kempen yang diterbitkan.",
    membersTitle: "Ahli Organisasi",
    membersDesc: "Lihat dan urus ahli dalam organisasi anda.",
    searchMembersPh: "Cari ahli mengikut nama atau e-mel...",
    loadingMembers: "Memuatkan ahli...",
    noMembers: "Tiada ahli ditemui.",
    inviteHint: "Jemput ahli pasukan atau pengguna ke organisasi anda.",
    member: "Ahli",
    addMember: "Tambah Ahli Organisasi",
    emailAddress: "Alamat E-mel",
    emailPh: "member@example.com",
    reportsTitle: "Laporan Organisasi",
    reportsDesc: "Analitik kewangan, jualan dan prestasi kempen.",
    loadingReports: "Menjana metrik laporan...",
    performanceBreakdown: "Pecahan Prestasi",
    performanceDesc: "Metrik prestasi kempen terperinci untuk organisasi anda.",
    ordersTitle: "Pesanan Organisasi",
    ordersDesc: "Lihat pesanan yang dibuat oleh ahli dalam kempen anda.",
    searchOrdersPh: "Cari mengikut ID Pesanan atau nama pembeli...",
    loadingOrders: "Memuatkan pesanan...",
    navigation: "Navigasi",
    allCampaigns: "Semua Kempen",
    createCampaign: "Cipta Kempen",
    loadingOrg: "Memuatkan organisasi…",
    accessDenied: "Akses Ditolak",
    accessDeniedDesc: "Akses ditolak. Akaun anda tidak boleh menggunakan modul Pengesahan Organisasi.",
    campaignYear: "Tahun Kempen",
    selectAllOrders: "Pilih semua pesanan ({{count}})",
    groupLabel: "Kumpulan",
    orderQueue: "Giliran Pesanan",
    showingOf: "Memaparkan {{shown}} daripada {{total}} pesanan dalam penapis semasa",
    searchOrderPh: "Cari pesanan, pembeli, kelas, saiz, jumlah",
    allStatus: "Semua Status",
    paidOnline: "Dibayar Dalam Talian",
    allTypes: "Semua Jenis",
    saveOrder: "Simpan Pesanan",
    allOrders: "Semua",
    pickHeader: "Pilih",
    memberNameWith: "Nama {{member}}",
    noActiveProducts: "Tiada produk aktif tersedia untuk organisasi ini",
    awaitingApprovalStatus: "Menunggu Kelulusan",
    termStudent: "Pelajar",
    termClass: "Kelas",
    termClasses: "Kelas",
    termParentOnline: "Ibu Bapa Dalam Talian",
    termAdminAssisted: "Dibantu Pentadbir",
    termMember: "Ahli",
    termOnlineBuyer: "Pembeli Dalam Talian",
    termCommittee: "Jawatankuasa",
    termDepartment: "Jabatan",
    termGroup: "Kumpulan",
    termTeam: "Pasukan",
    termEmployee: "Pekerja",
    termVolunteer: "Sukarelawan",
    studentNameHeader2: "Nama Pelajar",
    sportsHouseHeader2: "Rumah Sukan",
    createAssistedOrder: "Cipta Pesanan Berbantu",
    assistedModeDesc: "Mod daftar keluar berbantu untuk pembeli luar talian atau pembelian berbantu secara berjalan masuk.",
    selectProduct: "Pilih Produk",
    studentName: "Nama Pelajar",
    phoneNumber: "Nombor Telefon",
    address: "Alamat",
    size: "Saiz",
    quantity: "Kuantiti",
    classLabel: "Kelas",
    stockSuffix: "{{size}} ({{stock}} stok)",
    orderHeader2: "Pesanan",
    buyerHeader2: "Pembeli",
    qtyHeader2: "Kuantiti",
    amountHeader: "Jumlah",
    typeHeader: "Jenis",
    lastImportLabel: "Import terakhir:",
    noStudentsImported: "Tiada pelajar diimport lagi.",
    paidOrdersKpi: "Pesanan Dibayar",
    pendingOrdersKpi: "Pesanan Menunggu",
    studentsOrderedOfShort: "Pelajar memesan / Jumlah pelajar",
    membersKpi: "Ahli",
    teacherRole: "Guru",
    administratorRole: "Pentadbir",
    pendingSetup: "Menunggu Persediaan",
    searchMembersPh: "Cari ahli...",
    noMembersFound: "Tiada ahli ditemui",
    uploadCsvHint: "Muat naik CSV pelajar anda untuk bermula.",
    memberImportDesc: "Muat naik senarai ahli anda daripada fail CSV, atau muat turun templat untuk diisi dahulu.",
    directoryDesc: "Direktori ahli organisasi dan akaun berdaftar.",
    orgUploadCsvHint: "Muat naik CSV ahli anda untuk bermula.",
    statusActive: "aktif",
    fewerThanDb: "CSV yang dimuat naik mengandungi kurang {{members}} daripada pangkalan data semasa anda.",
    newMembersToImport: "{{members}} baharu untuk diimport:",
    previousReplaced: "{{members}} sebelumnya diganti:",
    labelsReady: "{{count}} label sedia untuk dicetak",
    allOrdered: "Semua pelajar telah memesan",
    readyForApproval: "Sedia untuk kelulusan",
    readyForApprovalDesc: "Senarai pelajar disahkan. Hantar kempen ini untuk semakan.",
    awaitingApproval: "Menunggu kelulusan",
    awaitingApprovalDesc: "{{name}} telah dihantar dan menunggu semakan Super Admin.",
    approvedReady: "Disahkan — sedia untuk diterbitkan",
    approvedReadyDesc: "{{name}} disahkan. Terbitkan untuk membuka pesanan.",
    closingSoon: "Kempen akan ditutup",
    closingSoonDesc: "{{name}} ditutup dalam {{days}} hari.",
    sendRemindersHint: "Hantar peringatan untuk mendorong pesanan.",
    noDescription: "Tiada penerangan",
    reportSuffix: "Laporan",
    dashTitle: "Gambaran keseluruhan operasi sekolah.",
    setupComplete: "Persediaan Lengkap",
    campaignRunning: "Kempen Berjalan",
    runningCampaign: "KEMPEN BERJALAN",
    published: "Diterbitkan",
    opened: "Dibuka:",
    closes: "Ditutup:",
    daysLeft: "({{days}} hari lagi)",
    orderProgress: "Kemajuan Pesanan",
    studentsOrderedOf: "Pelajar memesan / Jumlah pelajar:",
    studentsNeedOrder: "{{count}} pelajar masih perlu memesan",
    viewCampaign: "Lihat Kempen",
    sendReminders: "Hantar Peringatan",
    campaignTimeline: "Garis Masa Kempen",
    tlCreated: "Dicipta",
    tlSubmitted: "Dihantar",
    tlApproved: "Disahkan",
    tlPublished: "Diterbitkan",
    ordersOpen: "Pesanan Dibuka",
    distribution: "Agihan",
    kpiStudents: "PELAJAR",
    kpiParentsLinked: "IBU BAPA TERPAUT",
    kpiOrders: "PESANAN",
    kpiNotOrdered: "BELUM MEMESAN",
    actionRequired: "Tindakan Diperlukan",
    studentsHaventOrdered: "{{count}} pelajar belum memesan",
    daysUntilClosing: "{{days}} hari sebelum ditutup ({{date}}).",
    recentOrders: "Pesanan Terkini",
    viewAll: "Lihat semua",
    orderHeader: "PESANAN",
    buyerHeader: "PEMBELI",
    classHeader: "KELAS",
    qtyHeader: "KUANTITI",
    statusHeader: "STATUS",
    closesOn: "Ditutup {{date}}",
    itemsCount: "{{count}} item",
    viewAction: "Lihat",
    membersTitle: "Ahli",
    membersDesc: "Urus pentadbir sekolah dan direktori ahli anda.",
    schoolAdmins: "Pentadbir Sekolah",
    schoolAdminsDesc: "Orang yang mengurus akaun sekolah ini.",
    addAdministrator: "Tambah Pentadbir",
    owner: "Pemilik",
    active: "Aktif",
    studentImport: "Import Pelajar",
    studentImportDesc: "Muat naik senarai pelajar anda daripada fail CSV, atau muat turun templat untuk diisi dahulu.",
    lastImport: "IMPORT TERAKHIR",
    never: "Tidak Pernah",
    downloadCsvTemplate: "Muat Turun Templat CSV",
    uploadCsv: "Muat Naik CSV",
    schoolMembers: "Ahli Sekolah",
    schoolMembersDesc: "Pelajar, ibu bapa dan guru. Ahli dicipta secara automatik melalui import CSV, tuntutan ibu bapa, dan jemputan guru.",
    totalKpi: "JUMLAH",
    studentsKpi: "PELAJAR",
    inactiveKpi: "TIDAK AKTIF",
    filterStudents: "Pelajar",
    filterInactive: "Tidak Aktif",
    exportCsv: "Eksport CSV",
    importCsv: "Import CSV",
    nameHeader: "NAMA",
    classDeptHeader: "KELAS / JABATAN",
    sportsHouseHeader: "RUMAH SUKAN",
    parentLinkedHeader: "IBU BAPA TERPAUT",
    actionsHeader: "TINDAKAN",
    notLinked: "Tidak terpaut",
    linked: "Terpaut",
    showingMembers: "Memaparkan {{from}}–{{to}} daripada {{total}} ahli",
    rowsPerPage: "Baris setiap halaman:",
    previous: "Sebelum",
    next: "Seterusnya",
    reportsTitle: "Laporan Kempen",
    reportsDesc: "Analisis rekod pesanan, pembayaran dan penghantaran dalam konteks kempen.",
    campaignLabel: "KEMPEN",
    overview: "GAMBARAN KESELURUHAN",
    totalEnrolled: "Jumlah didaftar",
    acrossAllCampaigns: "Merentas semua kempen",
    paymentConfirmed: "Pembayaran disahkan",
    awaitingPayment: "Menunggu pembayaran",
    completionDelivery: "PENYELESAIAN & PENGHANTARAN PESANAN",
    completionPct: "PERATUS PENYELESAIAN %",
    paidAmount: "JUMLAH DIBAYAR",
    collected: "Dikumpul",
    inProduction: "DALAM PENGELUARAN",
    beingMade: "Sedang dibuat",
    packing: "PEMBUNGKUSAN",
    beingPacked: "Sedang dibungkus",
    inDelivery: "DALAM PENGHANTARAN",
    onTheWay: "Dalam perjalanan",
    completed: "SELESAI",
    delivered: "Dihantar",
    allStudents: "Semua Pelajar",
    notLinkedLabel: "Tidak Terpaut",
    orderedLabel: "Telah Memesan",
    pendingLabel: "Menunggu",
    studentNameHeader: "NAMA PELAJAR",
    parentStatusHeader: "STATUS IBU BAPA",
    orderStatusHeader: "STATUS PESANAN",
    lastOrderHeader: "PESANAN TERAKHIR",
    notOrdered: "Belum Memesan",
    showingStudents: "Memaparkan {{from}}–{{to}} daripada {{total}} pelajar",
    opsTitle: "Operasi Kempen",
    opsDesc: "Pesanan, pengeluaran, pembungkusan dan penghantaran diuruskan daripada konteks kempen.",
    printLabelDisabled: "Label cetakan dilumpuhkan untuk sekolah ini. Hubungi Super Admin.",
    openLabelPrint: "Buka Pusat Cetak Label",
    totalOrdersKpi: "JUMLAH PESANAN",
    onlineKpi: "DALAM TALIAN",
    manualKpi: "MANUAL",
    printLabelsKpi: "CETAK LABEL",
    orgBadge: "ORGANISASI",
    unableToLoadVerification: "Tidak dapat memuatkan pengesahan {{member}}.",
    reminderSentTo: "Peringatan dihantar kepada {{count}} {{members}}.",
    labelStudent: "Pelajar",
    labelStudents: "Pelajar",
    labelMember: "Ahli",
    labelMembers: "Ahli",
    labelEmployee: "Pekerja",
    labelEmployees: "Pekerja",
    labelVolunteer: "Sukarelawan",
    labelVolunteers: "Sukarelawan",
    labelPrincipal: "Pengetua",
    labelPresident: "Presiden",
    labelManager: "Pengurus",
    labelOwner: "Pemilik",
    labelCoordinator: "Penyelaras",
    labelAdministrator: "Pentadbir",
    memberCenterWith: "Pusat {{member}} — {{name}}",
    verifyImportWith: "Import dan sahkan {{members}}, kemudian hantar peringatan mengikut kumpulan atau kohort.",
    uploadMemberListWith: "Muat Naik Senarai {{label}} atau Data Organisasi",
    notifyContactsWith: "Beritahu kenalan untuk {{members}} yang belum membuat pesanan.",
    totalWithLabel: "Jumlah {{members}}",
    directoryWith: "Direktori {{member}}",
    noWith: "Tiada {{members}} ditemui",
    uploading: "Memuat naik...",
    loadingVerification: "Memuatkan data pengesahan...",
    filterBy: "Tapis {{type}}:",
    breakdownBy: "Pecahan Mengikut {{type}}",
    progressPct: "Kemajuan {{pct}}%",
    uncategorized: "Tidak Dikategorikan",
    noGroup: "Tiada Kumpulan",
    importResult: "Hasil Import",
    rowErrors: "Ralat Baris",
    typeAdmin: "Pentadbir {{type}}",
    orgTypeLabel: "Jenis Organisasi",
    descriptionLabel: "Penerangan",
    contactMobileNumber: "Nombor Telefon Bimbit",
    settingsDesc: "Urus profil, penjenamaan dan akaun penyelesaian pembayaran ruang kerja anda.",
    logoUploadDesc: "Muat naik logo rasmi anda untuk dipaparkan pada pengepala portal, kempen dan resit.",
    logoRecommendation: "Disyorkan: Imej segi empat sama (cth. 500x500px). Format: PNG, JPG, WebP sehingga 2MB.",
    exportCsvReport: "Eksport Laporan CSV",
    reportsAuditNote: "Semua laporan kewangan diaudit secara automatik dan dihadkan kepada ruang kerja organisasi anda.",
    memberCenter: "Pusat Ahli",
    verifyImportDesc: "Import dan sahkan ahli, kemudian hantar peringatan mengikut kumpulan atau kohort.",
    uploadMemberList: "Muat Naik Senarai Ahli atau Data Organisasi",
    requiredColumns: "Lajur diperlukan: Nama, Kelas dan Rumah Sukan. Pilihan: ID Ahli, Jantina, IC, Nota.",
    downloadSampleCsv: "Muat Turun CSV Contoh",
    dragDrop: "Seret dan lepas fail anda di sini",
    orChooseFile: "atau pilih fail",
    chooseFile: "Pilih Fail",
    uploadFile: "Muat Naik Fail",
    sendOrderReminders: "Hantar Peringatan Pesanan",
    notifyContacts: "Beritahu kenalan untuk ahli yang belum membuat pesanan.",
    allGroups: "Semua Kumpulan",
    sendReminders: "Hantar Peringatan",
    orderedLabel: "Telah Memesan",
    notOrderedLabel: "Belum Memesan",
    progress: "Kemajuan",
    verificationOverview: "Gambaran Keseluruhan Pengesahan",
    viewBy: "Lihat Mengikut:",
    group: "Kumpulan",
    category: "Kategori",
    filterGroup: "Tapis Kumpulan:",
    breakdownByGroup: "Pecahan Mengikut Kumpulan",
    memberDirectory: "Direktori Ahli",
    nameHeader: "Nama",
    ordersHeader: "Pesanan",
    parentHeader: "Ibu Bapa",
    noMembersFound: "Tiada ahli ditemui",
    noMembersHint: "Cuba kumpulan lain atau import data organisasi untuk mengisi direktori ini.",
    orgLogo: "Logo Organisasi",
    orgName: "Nama Organisasi / Kelab",
    addItem: "Tambah Item",
    addPayoutHint: "Klik \"+ Tambah Akaun Pembayaran\" di atas untuk menghantar akaun bank atau PayPal anda untuk penyelesaian pembayaran.",
    orgProfile: "Profil Organisasi",
    orgCampaigns: "Kempen Organisasi",
    recentCampaigns: "Kempen terkini yang dicipta oleh organisasi anda",
    recentOrders: "Pesanan Ahli Terkini",
    recentOrdersDesc: "Pembelian dan pembayaran ahli terkini",
    dashSettings: "Tetapan Organisasi",
    sending: "Menghantar...",
    schoolProfile: "Profil Sekolah",
    schoolLogo: "Logo Sekolah",
    changeLogo: "Tukar Logo",
    schoolName: "Nama Sekolah",
    addPayoutAccount: "Tambah Akaun Pembayaran",
    payoutDesc: "Kami memerlukan anda menghantar butiran akaun pembayaran untuk tujuan pengesahan dan penyelesaian pembayaran.",
    primary: "Utama",
    currencyColon: "Mata Wang:",
    addBankAccount: "Tambah Akaun Bank",
    bank: "Bank",
    accountNumber: "Nombor akaun",
    beneficiaryName: "Nama penerima",
    idType: "Jenis ID",
    idNumber: "Nombor ID",
    currency: "Mata Wang",
    addPaypal: "Tambah Akaun PayPal",
    paypalEmail: "E-mel PayPal",
    accountHolderName: "Nama Pemegang Akaun",
    saving: "Menyimpan...",
    back: "Kembali",
  },
  campaign: {
    searchCampaignsPh: "Cari kempen...",
    allStatus: "Semua Status",
    noCampaignsYet: "Tiada kempen lagi",
    viewCampaign: "Lihat kempen",
    previewCampaign: "Pratonton kempen",
    moreActions: "Tindakan lanjut",
    studentListRequired: "Senarai pelajar diperlukan",
    scanQr: "Imbas kod QR untuk membuka kedai kempen",
    campaignDetails: "Butiran Kempen",
    orderCutoff: "Tamat Tempahan",
    paymentDue: "Pembayaran Dijangka",
    distributionDate: "Tarikh Agihan",
    distributionMethod: "Kaedah Agihan",
    collectionPoint: "Titik Kutipan",
    allocation: "Peruntukan",
    quantityTarget: "Sasaran Kuantiti",
    minMaxOrder: "Tempahan Min / Maks",
    noItems: "Tiada item lagi",
    noPayments: "Tiada pembayaran lagi",
    qrPasses: "Pas QR",
    qrDesc: "Kod QR dijana secara automatik selepas pembayaran berjaya. Satu QR bagi setiap pesanan.",
    noQr: "Tiada pas QR dijana lagi",
    noQrHint: "Kod QR muncul selepas pesanan dibayar",
    productionDesc: "Pantau status pengeluaran dan pemprosesan kumpulan di sini.",
    packingDesc: "Urus senarai pembungkusan dan operasi pembungkusan kumpulan di sini.",
    delivery: "Penghantaran / Kutipan",
    deliveryDesc: "Pantau penghantaran, kutipan dan agihan di sini.",
    groupEventsDesc: "Acara pesanan berkumpulan untuk organisasi anda",
    createFirstDesc: "Cipta kempen pesanan berkumpulan pertama anda",
    studentCsvHint: "Muat naik dan sahkan CSV pelajar sebelum menghantar kempen ini untuk kelulusan.",
    sku: "SKU:",
    itemsCount: "Item ({{count}})",
    ordersCount: "Pesanan ({{count}})",
    orderHash: "Pesanan #",
    duplicate: "Duplikat",
    totalItemsLabel: "Jumlah Item",
  },

  school: {
    membersTitle: "Ahli",
    membersDesc: "Urus pentadbir sekolah dan direktori ahli anda.",
    searchMembersPh: "Cari ahli...",
    reportsTitle: "Laporan Kempen",
    reportsDesc: "Analisis rekod pesanan, pembayaran dan penghantaran dalam konteks kempen.",
    paidOrdersKpi: "Pesanan Dibayar",
    pendingOrdersKpi: "Pesanan Menunggu",
    studentsOrderedOfShort: "Pelajar memesan / Jumlah pelajar",
    teacherRole: "Guru",
    administratorRole: "Pentadbir",
    pendingSetup: "Menunggu Persediaan",
    noMembersFound: "Tiada ahli ditemui",
    uploadCsvHint: "Muat naik CSV pelajar anda untuk bermula.",
    memberImportDesc: "Muat naik senarai ahli anda daripada fail CSV, atau muat turun templat untuk diisi dahulu.",
    directoryDesc: "Direktori ahli organisasi dan akaun berdaftar.",
    orgUploadCsvHint: "Muat naik CSV ahli anda untuk bermula.",
    statusActive: "aktif",
    fewerThanDb: "CSV yang dimuat naik mengandungi kurang {{members}} daripada pangkalan data semasa anda.",
    newMembersToImport: "{{members}} baharu untuk diimport:",
    previousReplaced: "{{members}} sebelumnya diganti:",
    labelsReady: "{{count}} label sedia untuk dicetak",
    allOrdered: "Semua pelajar telah memesan",
    readyForApproval: "Sedia untuk kelulusan",
    readyForApprovalDesc: "Senarai pelajar disahkan. Hantar kempen ini untuk semakan.",
    awaitingApproval: "Menunggu kelulusan",
    awaitingApprovalDesc: "{{name}} telah dihantar dan menunggu semakan Super Admin.",
    approvedReady: "Disahkan — sedia untuk diterbitkan",
    approvedReadyDesc: "{{name}} disahkan. Terbitkan untuk membuka pesanan.",
    closingSoon: "Kempen akan ditutup",
    closingSoonDesc: "{{name}} ditutup dalam {{days}} hari.",
    sendRemindersHint: "Hantar peringatan untuk mendorong pesanan.",
    noDescription: "Tiada penerangan",
    reportSuffix: "Laporan",
    dashTitle: "Gambaran keseluruhan operasi sekolah.",
    setupComplete: "Persediaan Lengkap",
    campaignRunning: "Kempen Berjalan",
    runningCampaign: "KEMPEN BERJALAN",
    published: "Diterbitkan",
    opened: "Dibuka:",
    closes: "Ditutup:",
    daysLeft: "({{days}} hari lagi)",
    orderProgress: "Kemajuan Pesanan",
    studentsOrderedOf: "Pelajar memesan / Jumlah pelajar:",
    studentsNeedOrder: "{{count}} pelajar masih perlu memesan",
    viewCampaign: "Lihat Kempen",
    sendReminders: "Hantar Peringatan",
    campaignTimeline: "Garis Masa Kempen",
    tlCreated: "Dicipta",
    tlSubmitted: "Dihantar",
    tlApproved: "Disahkan",
    tlPublished: "Diterbitkan",
    noActiveCampaignsDesc: "Cipta kempen untuk mula menerima pesanan.",
    otherCampaigns: "Kempen Lain",
    opensOn: "Buka {{date}}",
    ordersOpen: "Pesanan Dibuka",
    distribution: "Agihan",
    kpiStudents: "PELAJAR",
    kpiParentsLinked: "IBU BAPA TERPAUT",
    kpiOrders: "PESANAN",
    kpiNotOrdered: "BELUM MEMESAN",
    actionRequired: "Tindakan Diperlukan",
    studentsHaventOrdered: "{{count}} pelajar belum memesan",
    daysUntilClosing: "{{days}} hari sebelum ditutup ({{date}}).",
    recentOrders: "Pesanan Ahli Terkini",
    viewAll: "Lihat semua",
    orderHeader: "PESANAN",
    buyerHeader: "PEMBELI",
    classHeader: "KELAS",
    qtyHeader: "KUANTITI",
    statusHeader: "STATUS",
    closesOn: "Ditutup {{date}}",
    itemsCount: "{{count}} item",
    viewAction: "Lihat",
    schoolAdmins: "Pentadbir Sekolah",
    schoolAdminsDesc: "Orang yang mengurus akaun sekolah ini.",
    addAdministrator: "Tambah Pentadbir",
    owner: "Pemilik",
    active: "Aktif",
    studentImport: "Import Pelajar",
    studentImportDesc: "Muat naik senarai pelajar anda daripada fail CSV, atau muat turun templat untuk diisi dahulu.",
    lastImport: "IMPORT TERAKHIR",
    never: "Tidak Pernah",
    downloadCsvTemplate: "Muat Turun Templat CSV",
    uploadCsv: "Muat Naik CSV",
    schoolMembers: "Ahli Sekolah",
    schoolMembersDesc: "Pelajar, ibu bapa dan guru. Ahli dicipta secara automatik melalui import CSV, tuntutan ibu bapa, dan jemputan guru.",
    totalKpi: "JUMLAH",
    studentsKpi: "PELAJAR",
    inactiveKpi: "TIDAK AKTIF",
    filterStudents: "Pelajar",
    filterInactive: "Tidak Aktif",
    exportCsv: "Eksport CSV",
    importCsv: "Import CSV",
    nameHeader: "Nama",
    classDeptHeader: "KELAS / JABATAN",
    sportsHouseHeader: "RUMAH SUKAN",
    parentLinkedHeader: "IBU BAPA TERPAUT",
    actionsHeader: "TINDAKAN",
    notLinked: "Tidak terpaut",
    linked: "Terpaut",
    showingMembers: "Memaparkan {{from}}–{{to}} daripada {{total}} ahli",
    rowsPerPage: "Baris setiap halaman:",
    previous: "Sebelum",
    next: "Seterusnya",
    campaignLabel: "KEMPEN",
    overview: "GAMBARAN KESELURUHAN",
    totalEnrolled: "Jumlah didaftar",
    acrossAllCampaigns: "Merentas semua kempen",
    paymentConfirmed: "Pembayaran disahkan",
    awaitingPayment: "Menunggu pembayaran",
    completionDelivery: "PENYELESAIAN & PENGHANTARAN PESANAN",
    completionPct: "PERATUS PENYELESAIAN %",
    paidAmount: "JUMLAH DIBAYAR",
    collected: "Dikumpul",
    inProduction: "DALAM PENGELUARAN",
    beingMade: "Sedang dibuat",
    packing: "PEMBUNGKUSAN",
    beingPacked: "Sedang dibungkus",
    inDelivery: "DALAM PENGHANTARAN",
    onTheWay: "Dalam perjalanan",
    completed: "SELESAI",
    delivered: "Dihantar",
    allStudents: "Semua Pelajar",
    notLinkedLabel: "Tidak Terpaut",
    orderedLabel: "Telah Memesan",
    pendingLabel: "Menunggu",
    studentNameHeader: "NAMA PELAJAR",
    parentStatusHeader: "STATUS IBU BAPA",
    orderStatusHeader: "STATUS PESANAN",
    lastOrderHeader: "PESANAN TERAKHIR",
    notOrdered: "Belum Memesan",
    showingStudents: "Memaparkan {{from}}–{{to}} daripada {{total}} pelajar",
    opsTitle: "Operasi Kempen",
    opsDesc: "Pesanan, pengeluaran, pembungkusan dan penghantaran diuruskan daripada konteks kempen.",
    printLabelDisabled: "Label cetakan dilumpuhkan untuk sekolah ini. Hubungi Super Admin.",
    openLabelPrint: "Buka Pusat Cetak Label",
    totalOrdersKpi: "JUMLAH PESANAN",
    onlineKpi: "DALAM TALIAN",
    manualKpi: "MANUAL",
    printLabelsKpi: "CETAK LABEL",
    orgBadge: "ORGANISASI",
    createAssistedOrder: "Cipta Pesanan Berbantu",
    assistedModeDesc: "Mod daftar keluar berbantu untuk pembeli luar talian atau pembelian berbantu secara berjalan masuk.",
    selectProduct: "Pilih Produk",
    noActiveProducts: "Tiada produk aktif tersedia untuk organisasi ini",
    memberNameWith: "Nama {{member}}",
    saveOrder: "Simpan Pesanan",
    orderQueue: "Giliran Pesanan",
    showingOf: "Memaparkan {{shown}} daripada {{total}} pesanan dalam penapis semasa",
    searchOrderPh: "Cari pesanan, pembeli, kelas, saiz, jumlah",
    allStatus: "Semua Status",
    paidOnline: "Dibayar Dalam Talian",
    allTypes: "Semua Jenis",
    allOrders: "Semua",
    pickHeader: "Pilih",
    selectAllOrders: "Pilih semua pesanan ({{count}})",
    groupLabel: "Kumpulan",
    awaitingApprovalStatus: "Menunggu Kelulusan",
    labelsReady: "{{count}} label sedia untuk dicetak",
    teacherRole: "Guru",
    administratorRole: "Pentadbir",
    pendingSetup: "Menunggu Persediaan",
    searchMembersPh: "Cari ahli...",
    noMembersFound: "Tiada ahli ditemui",
    uploadCsvHint: "Muat naik CSV pelajar anda untuk bermula.",
    memberImportDesc: "Muat naik senarai ahli anda daripada fail CSV, atau muat turun templat untuk diisi dahulu.",
    directoryDesc: "Direktori ahli organisasi dan akaun berdaftar.",
    orgUploadCsvHint: "Muat naik CSV ahli anda untuk bermula.",
    statusActive: "aktif",
    fewerThanDb: "CSV yang dimuat naik mengandungi kurang {{members}} daripada pangkalan data semasa anda.",
    newMembersToImport: "{{members}} baharu untuk diimport:",
    previousReplaced: "{{members}} sebelumnya diganti:",
    lastImportLabel: "Import terakhir:",
    noStudentsImported: "Tiada pelajar diimport lagi.",
    paidOrdersKpi: "Pesanan Dibayar",
    pendingOrdersKpi: "Pesanan Menunggu",
    studentsOrderedOfShort: "Pelajar memesan / Jumlah pelajar",
    studentNameHeader2: "Nama Pelajar",
    sportsHouseHeader2: "Rumah Sukan",
    termStudent: "Pelajar",
    termClass: "Kelas",
    termClasses: "Kelas",
    termParentOnline: "Ibu Bapa Dalam Talian",
    termAdminAssisted: "Dibantu Pentadbir",
    termMember: "Ahli",
    termOnlineBuyer: "Pembeli Dalam Talian",
    termCommittee: "Jawatankuasa",
    termDepartment: "Jabatan",
    termGroup: "Kumpulan",
    termTeam: "Pasukan",
    termEmployee: "Pekerja",
    termVolunteer: "Sukarelawan",

    phoneNumber: "Nombor Telefon",
    address: "Alamat",
    size: "Saiz",
    quantity: "Kuantiti",
    stockSuffix: "{{size}} ({{stock}} stok)",
    orderHeader2: "Pesanan",
    buyerHeader2: "Pembeli",
    qtyHeader2: "Kuantiti",
    amountHeader: "Jumlah",
    typeHeader: "Jenis",
    classLabel: "Kelas",
    studentName: "Nama Pelajar",
    membersKpi: "Ahli",

    paymentMethod2: "Kaedah Pembayaran",
    manualPaymentReview: "Semakan Pembayaran Manual",
    schoolPaymentApproval: "Kelulusan Pembayaran Sekolah",
    orgPaymentConfirmation: "Pengesahan Pembayaran Organisasi",
    printLabels2: "Cetak Label",
    queueFirstWorkflow: "Aliran kerja giliran pertama: pilih rekod, pratonton PDF, kemudian sahkan cetakan untuk log audit.",
    manualVerified: "Disahkan Manual",
    pending2: "Menunggu",
    pageOf: "Halaman {{page}} daripada {{total}}",
    type2: "Jenis",
    name2: "Nama",
    adminsTitle: "Pentadbir Sekolah",
    campaign2: "Kempen",
    overview2: "Gambaran Keseluruhan",

    statusActiveLabel: "Aktif",

    kpiParents: "Ibu Bapa",
    kpiEmployees: "Pekerja",
    kpiParticipants: "Peserta",
    kpiVolunteers: "Sukarelawan",

    complimentary: "Percuma",
    notes: "Nota",

  },
  term: {
    organization: "Organisasi",
    school: "Sekolah",
    company: "Syarikat",
    club: "Kelab",
    university: "Universiti",
    member: "Ahli",
    employee: "Pekerja",
    student: "Pelajar",
    memberLower: "ahli",
    employeeLower: "pekerja",
    studentLower: "pelajar",
    group: "Kumpulan",
    class: "Kelas",
    department: "Jabatan",
    committee: "Jawatankuasa",
    faculty: "Fakulti",
    groupLower: "kumpulan",
    classLower: "kelas",
    departmentLower: "jabatan",
    committeeLower: "jawatankuasa",
    facultyLower: "fakulti",
    groupPlaceholderClass: "cth. 1A",
    groupPlaceholderTeam: "cth. Pasukan Jualan",
    groupPlaceholderCommittee: "cth. Jawatankuasa Acara",
    groupPlaceholderFaculty: "cth. Fakulti Kejuruteraan",
    groupPlaceholderGeneric: "cth. Kumpulan A",
  },
  campaignForm: {
    createCampaign: "Cipta Kempen",
    editCampaign: "Edit Kempen",
    campaignApproved: "Kempen (Diluluskan)",
    blueprintSubtitle: "Pilih blueprint untuk bermula dengan cepat",
    formSubtitle: "Sediakan acara pesanan kumpulan anda",
    chooseBlueprint: "Pilih Blueprint",
    chooseBlueprintDesc: "Pilih templat untuk mengkonfigurasi kempen anda secara automatik. Anda masih boleh mengubah segala-galanya kemudian.",
    orBlankCampaign: "Atau mulakan dengan kempen kosong",
    fromLabel: "Dari",
    usingBlueprint: "Menggunakan blueprint: {{label}}",
    change: "Tukar",
    bpBlank: "Kempen Kosong",
    bpBlankDesc: "Mula dari kosong dengan tetapan lalai.",
    bpSportsWear: "Pakaian Sukan & Atletik",
    bpSportsWearDesc: "Kemeja-T, jersi, dan pakaian hari sukan dengan variasi saiz.",
    bpUniform: "Uniform & Kelengkapan Rasmi",
    bpUniformDesc: "Set uniform standard dan kelengkapan rasmi dengan saiz standard.",
    bpMarathon: "Maraton / Larian Riadah",
    bpMarathonDesc: "Nombor lumba, kemeja penamat, dan cenderamata acara.",
    bpProductSale: "Jualan Produk",
    bpProductSaleDesc: "Jualan produk am dengan penjejakan inventori.",
    bpTicketing: "Tiket",
    bpTicketingDesc: "Tiket acara dengan harga berperingkat dan kutipan QR.",
    bpDonation: "Derma",
    bpDonationDesc: "Pengumpulan dana dengan pembayaran percuma dan akses terbuka.",
    bpMembership: "Keahlian",
    bpMembershipDesc: "Keahlian kelab atau persatuan dengan pengesahan ahli.",
    bpService: "Tempahan Perkhidmatan",
    bpServiceDesc: "Tempah perkhidmatan atau janji temu dengan slot masa.",
    bpProperty: "Jelajah Hartanah",
    bpPropertyDesc: "Penyenaraian hartanah dan pendaftaran rumah terbuka.",
    bpVehicle: "Promosi Kenderaan",
    bpVehicleDesc: "Jualan kenderaan, ujian pandu, dan kempen promosi.",
    bpSportsWearName: "Kempen Pakaian Sukan Hari Sukan Tahunan",
    bpSportsWearDesc2: "Jersi pasukan rasmi, kemeja-T sukan, dan kelengkapan atletik dengan pilihan saiz.",
    bpUniformName: "Set Uniform & Pakaian Rasmi 2026",
    bpUniformDesc2: "Set uniform standard, kemeja, dan pakaian rasmi dengan saiz standard.",
    bpMarathonName: "Maraton & Larian Riadah Tahunan 2026",
    bpMarathonDesc2: "Nombor lumba, kemeja-T acara, pingat penamat, dan pendaftaran larian riadah.",
    bpProductSaleName: "Jualan Eksklusif Barangan Rasmi & Produk",
    bpProductSaleDesc2: "Barangan rasmi kelab, pakaian, aksesori, dan item promosi.",
    bpTicketingName: "Makan Malam Gala & Tiket Acara Tahunan",
    bpTicketingDesc2: "Tiket acara, pas konsert, dan kemasukan dengan pengesahan pas QR.",
    bpDonationName: "Kempen Pengumpulan Dana Komuniti & Kebajikan",
    bpDonationDesc2: "Kempen pengumpulan dana untuk inisiatif kebajikan, projek komuniti, dan derma sukarela.",
    bpMembershipName: "Pendaftaran Keahlian Organisasi Tahunan 2026",
    bpMembershipDesc2: "Yuran keahlian tahunan kelab, persatuan, atau komuniti dan pendaftaran ahli.",
    bpServiceName: "Tempahan Perkhidmatan Profesional & Janji Temu",
    bpServiceDesc2: "Tempah janji temu, sesi kejurulatihan, atau slot masa kemudahan dengan tempahan berjadual.",
    bpPropertyName: "Jelajah Hartanah Eksklusif & Acara Rumah Terbuka",
    bpPropertyDesc2: "Pendaftaran rumah terbuka VIP, janji temu melihat unit, dan tempahan jelajah.",
    bpVehicleName: "Promosi Pelancaran Kenderaan Baharu & Ujian Pandu",
    bpVehicleDesc2: "Tempah slot ujian pandu, rizab tawaran promosi, dan kunci harga pelancaran khas.",
    lockedBanner: "Kempen ini {{status}}. Penyuntingan langsung dikunci.",
    lockedSubtitle: "Kempen ini diluluskan dan dikunci. Hantar permintaan perubahan untuk mencadangkan suntingan.",
    lockedDesc: "Untuk mengubah harga, produk, stok, variasi, tarikh, atau imej, hantar permintaan perubahan untuk semakan Pentadbir Super. Kempen langsung kekal tidak berubah sehingga diluluskan.",
    pendingRequest: "Permintaan perubahan sedang menunggu semakan",
    reasonLabel: "Sebab: {{reason}}",
    submittedStatus: "Dihantar {{date}} · Status: {{status}}",
    cancelRequest: "Batal permintaan",
    requestChange: "Minta Perubahan",
    submitChangeRequest: "Hantar Permintaan Perubahan",
    changeRequestDesc: "Buat perubahan anda dalam borang di bawah, kemudian terangkan sebabnya. Kempen langsung tidak akan berubah sehingga Pentadbir Super meluluskan.",
    changeReasonPh: "cth., Perlu tambah saiz M dan laraskan harga untuk kempen yang diluluskan",
    submitting: "Menghantar...",
    submitRequest: "Hantar Permintaan",
    campaignInfo: "Maklumat Kempen",
    required: "Diperlukan",
    campaignName: "Nama Kempen",
    campaignNamePh: "cth., Hari Sukan 2026",
    campaignType: "Jenis Kempen",
    selectType: "Pilih jenis...",
    basePrice: "Harga Asas",
    basePriceError: "Harga asas diperlukan dan mesti lebih daripada RM 0.00",
    skuLabel: "SKU",
    skuPh: "cth., SD2026-TS",
    sleeveType: "Jenis Lengan",
    shortSleevePrice: "Harga Lengan Pendek (RM)",
    longSleevePrice: "Harga Lengan Panjang (RM)",
    ticketingTitle: "Konfigurasi Acara & Tiket",
    ticketingPreset: "Preset Tiket",
    venueLabel: "Tempat / Lokasi Acara",
    venuePh: "cth., Dewan Utama / Siaran Dalam Talian",
    tierLabel: "Kategori / Peringkat Tiket",
    tierPh: "cth., Pas Kemasukan VIP / Kemasukan Am",
    ticketingNote: "Penebusan pas digital QR automatik diaktifkan untuk pemegang tiket selepas pengesahan.",
    donationTitle: "Persediaan Pengumpulan Dana & Sumbangan",
    donationPreset: "Preset Derma",
    causeLabel: "Punca Penerima / Matlamat Projek",
    causePh: "cth., Dana Perpustakaan Komuniti & Pembelian Peralatan",
    donationNote: "Notifikasi resit derma dan dasar pembayaran sukarela aktif.",
    membershipTitle: "Persediaan Peringkat & Faedah Keahlian",
    membershipPreset: "Preset Keahlian",
    tierNameLabel: "Nama Peringkat Keahlian",
    tierNamePh: "cth., Pas Emas Tahunan",
    validityLabel: "Tempoh Sah",
    validityPh: "cth., 1 Tahun (Jan 2026 - Dis 2026)",
    serviceTitle: "Persediaan Tempahan Perkhidmatan & Slot",
    servicePreset: "Preset Perkhidmatan",
    durationLabel: "Tempoh Sesi",
    durationPh: "cth., 60 Minit setiap sesi",
    locationLabel: "Lokasi / Tempat",
    locationPh: "cth., Studio Utama & Pusat Janji Temu",
    propertyTitle: "Persediaan Pelancaran Hartanah & Jelajah",
    propertyPreset: "Preset Hartanah",
    venueLabel2: "Tempat Jelajah / Galeri Jualan",
    venuePh2: "cth., Pusat Konvensyen Pusat & Galeri Jualan",
    unitLabel: "Kategori Unit Pilihan",
    unitPh: "cth., Kondominium Mewah & Suite Eksekutif",
    vehicleTitle: "Persediaan Pelancaran Kenderaan & Ujian Pandu",
    vehiclePreset: "Preset Kenderaan",
    showroomLabel: "Lokasi Pameran / Ujian Pandu",
    showroomPh: "cth., Pameran Utama & Litar Ujian",
    modelLabel: "Model / Edisi Kenderaan",
    modelPh: "cth., Edisi Prestasi Sukan 2026",
    sizeVariations: "Saiz & Variasi",
    sizeVariationsHint: "Dayakan saiz yang anda tawarkan. Gunakan Gantian Harga untuk menetapkan harga berbeza untuk saiz lebih besar (cth., 3XL, 4XL, 5XL). Biarkan kosong untuk menggunakan harga asas lengan.",
    sizeHeader: "Saiz",
    enabledHeader: "Dibolehkan",
    priceOverrideHeader: "Gantian Harga (RM)",
    skuHeader: "SKU",
    priceLabel: "Harga:",
    setBasePrice: "Tetapkan harga asas",
    sizesLabel: "Saiz:",
    campaignDetails: "Butiran Kempen",
    campaignCover: "Kulit Kempen",
    coverDesc: "Banner utama untuk pratonton kempen awam. Imej pemasaran / penjenamaan — bukan imej produk.",
    noCoverYet: "Tiada kulit lagi — banner lalai sekolah atau banner Cheeco akan dipaparkan pada halaman awam.",
    coverPoster: "Poster Kulit",
    productImage: "Imej Produk",
    productImageHint: "(diperlukan sebelum hantar)",
    productImageDesc: "Muat naik foto pakaian/produk sebenar. Imej ini dipaparkan kepada ibu bapa pada halaman kempen dan dalam bakul mereka.",
    productImageRequired: "Imej produk diperlukan sebelum anda boleh menghantar kempen ini.",
    shortDescription: "Penerangan Ringkas",
    shortDescriptionPh: "Terangkan tentang kempen ini...",
    orderCutoff: "Tamat Pesanan",
    orderCutoffPh: "Pilih tarikh & masa tamat",
    paymentDue: "Pembayaran Dijangka",
    paymentDuePh: "Pilih tarikh & masa pembayaran",
    distributionDate: "Tarikh Agihan / Kutipan",
    distributionDatePh: "Pilih tarikh & masa agihan",
    visibility: "Keterlihatan",
    buyerAccessMode: "Mod Akses Pembeli",
    buyerAccessDesc: "Pilih sama ada kempen ini terhad kepada Ahli Organisasi atau terbuka kepada awam.",
    membersOnly: "🔒 Ahli Sahaja",
    membersOnlyDesc: "Hanya Ahli Organisasi yang diluluskan boleh melihat dan membeli.",
    publicOpen: "🌐 Awam (Terbuka kepada Semua)",
    publicOpenDesc: "Sesiapa dengan pautan atau kod QR boleh membeli terus tanpa menyertai.",
    paymentSettings: "Tetapan Pembayaran",
    defaultPaymentMethod: "Kaedah Pembayaran Lalai",
    defaultAllocationMethod: "Kaedah Peruntukan Lalai",
    distributionTitle: "Agihan",
    distributionMethod: "Kaedah Agihan",
    collectionPoint: "Titik Kutipan / Tempat",
    collectionPointPh: "cth., {{default}}",
    sportsHouseConfig: "Konfigurasi Rumah Sukan",
    sportsHouseDesc: "Kumpulkan pelajar ke dalam rumah sukan supaya setiap variasi jersi menunjukkan warna dan lambang rumah yang betul.",
    assignmentMethod: "Kaedah Penugasan",
    useCsv: "Guna CSV Pelajar",
    parentSelect: "Ibu Bapa Pilih Semasa Daftar Keluar",
    noHouse: "Tiada Rumah Sukan",
    recommended: "Disyorkan",
    recommendedDesc: "Disyorkan — sepadan dengan rekod rasmi",
    csvHelpText: "CSV Pelajar membaca Rumah Sukan pelajar daripada senarai ahli yang diimport dan menetapkannya secara automatik. Ibu bapa tidak boleh mengubahnya.",
    sportsHouses: "Rumah Sukan",
    addHouse: "+ Tambah Rumah",
    noHousesYet: "Tiada rumah ditambah lagi. Tambah rumah (cth. Merah, Biru, Hijau, Kuning).",
    housePh: "cth., Rumah Merah",
    houseColour: "Warna rumah",
    removeHouse: "Buang rumah",
    parentsChoose: "Ibu bapa akan memilih salah satu rumah ini semasa daftar keluar.",
    quantitySettings: "Tetapan Kuantiti",
    quantityTarget: "Sasaran Kuantiti",
    minOrderQty: "Kuantiti Min Pesanan",
    maxOrderQty: "Kuantiti Maks Pesanan",
    saveDraft: "Simpan sebagai Draf",
    publishing: "Menerbitkan...",
    publish: "Terbitkan",
    saveContinue: "Simpan & Teruskan",
    visOrgOnly: "Organisasi Sahaja",
    visPublic: "Awam",
    visPrivate: "Peribadi (Jemputan Sahaja)",
    pmOnline: "Pembayaran Dalam Talian",
    pmManual: "Pembayaran Manual",
    pmFunding: "Pembiayaan / Ditaja",
    pmComplimentary: "Percuma (FOC)",
    allocOpen: "Akses Terbuka",
    allocCodes: "Kod Kempen",
    allocManual: "Kelulusan Manual",
    distCollection: "Kutipan",
    distDelivery: "Penghantaran",
    distBoth: "Kedua-duanya",
    errLoadCampaign: "Gagal memuatkan kempen",
    errUploadPoster: "Gagal memuat naik poster",
    errNameRequired: "Nama kempen diperlukan",
    errBasePriceRequired: "Harga asas diperlukan sebelum menerbitkan",
    errSizeRequired: "Sekurang-kurangnya satu saiz mesti dibolehkan sebelum menerbitkan",
    errOpeningRequired: "Tarikh mula diperlukan sebelum menerbitkan",
    errClosingRequired: "Tarikh tutup diperlukan sebelum menerbitkan",
    errClosingAfterOpening: "Tarikh tutup mesti selepas tarikh mula",
    errHouseRequired: "Tambah sekurang-kurangnya satu rumah sukan sebelum menerbitkan",
    errSave: "Gagal menyimpan kempen",
    errPublish: "Gagal menerbitkan kempen",
    errChangeReason: "Sila berikan sebab untuk permintaan perubahan (sekurang-kurangnya 3 aksara).",
    errSubmitChange: "Gagal menghantar permintaan perubahan",
    confirmCancelChange: "Batal permintaan perubahan ini? Kempen akan kekal tidak berubah.",
    errCancelChange: "Gagal membatalkan permintaan perubahan",
    useCampaignDefault: "Guna Lalai Kempen",
    autoAlloc: "Automatik",
    codeRequired: "Kod Diperlukan",
    editItem: "Edit Produk",
    addItem: "Tambah Produk",
    whatIsAvailable: "Apakah yang tersedia untuk dipesan?",
    itemInfo: "Maklumat Produk",
    itemName: "Nama Produk",
    itemNamePh: "cth., Kemeja Sukan",
    itemImage: "Imej Produk",
    houseJerseyImages: "Imej Jersi Rumah Sukan",
    houseJerseyDesc: "Muat naik imej jersi berasingan untuk setiap rumah supaya ibu bapa melihat warna rumah yang betul semasa daftar keluar.",
    houseJerseyImage: "Imej Jersi Rumah",
    descLabel: "Penerangan",
    descPh: "Terangkan produk ini...",
    sellingPrice: "Harga Jualan",
    unlimited: "Tidak Terhad",
    limited: "Terhad",
    availableQtyPh: "Kuantiti tersedia",
    optionsOptional: "Pilihan (Pilihan)",
    optionsDesc: "Tambah pilihan mudah seperti Saiz, Warna, Jantina. Sistem akan menjana semua kombinasi secara automatik.",
    optionNamePh: "Nama pilihan (cth., Saiz)",
    optionValuesPh: "Nilai (satu setiap baris atau dipisahkan koma)",
    addOption: "Tambah Pilihan",
    paymentOverride: "Gantian Pembayaran (Pilihan)",
    paymentOverrideDesc: "Gantikan lalai kempen untuk item ini, atau biarkan kosong untuk menggunakan tetapan kempen.",
    itemPaymentMethod: "Kaedah Pembayaran",
    allocationMethodLabel: "Kaedah Peruntukan",
    updateItem: "Kemas Kini Produk",
    saveItem: "Simpan Produk",
    errLoadItem: "Gagal memuatkan produk",
    errUploadImage: "Gagal memuat naik imej",
    errUploadHouseImage: "Gagal memuat naik imej rumah",
    errItemNameRequired: "Nama produk diperlukan",
    errSellingPrice: "Harga jualan diperlukan",
    errQtyRequired: "Kuantiti tersedia diperlukan apabila tidak terhad",
    errSaveItem: "Gagal menyimpan produk",
    ticketTiers: "Peringkat Tiket",
    addTicketTier: "+ Tambah Peringkat Tiket",
    tierName: "Nama Peringkat",
    tierPrice: "Harga (RM)",
    tierCapacity: "Kapasiti / Kuantiti",
    tierSku: "SKU",
    removeTier: "Buang",
    tierNameRequired: "Nama peringkat diperlukan.",
    tierDuplicateName: "Nama peringkat mestilah unik dalam kempen.",
    tierPriceRequired: "Harga peringkat diperlukan dan mesti lebih daripada 0.",
    tierCapacityRequired: "Kapasiti peringkat diperlukan dan mesti lebih daripada 0.",
    tierSkuDuplicate: "SKU peringkat mestilah unik dalam kempen.",
    atLeastOneTier: "Sekurang-kurangnya satu peringkat tiket diperlukan.",
    tiersHint: "Setiap peringkat ialah tiket yang boleh dibeli secara berasingan dengan harga dan kapasitinya sendiri.",
    tiersLabel: "Peringkat:",
    capacityLeft: "{{n}} lagi",
    selectTierPh: "Pilih peringkat untuk melihat harganya.",
    errInvalidFormat: "Format tidak sah: {{type}}. Hanya JPG, PNG, dan WebP diterima.",
    errFileTooLarge: "Fail terlalu besar: {{size}}. Maksimum ialah {{max}} MB.",
    errImageRatio: "Nisbah imej ialah {{ratio}} tetapi disyorkan {{recommended}} ({{label}}). Imej mungkin dipangkas atau dipaparkan dengan tidak betul.",
    recommended2: "Disyorkan: {{ratio}}",
    uploading: "Memuat naik...",
    clickToUpload: "Klik untuk memuat naik atau seret dan lepas",
    uploadFormats: "JPG, PNG, WebP sehingga {{max}} MB",
    previewAlt: "Pratonton",
    removeImage: "Buang imej",
    webpNotice: "Imej akan ditukar kepada WebP secara automatik dan dioptimumkan untuk penghantaran web.",
    selectDate: "Pilih tarikh",
    ratioCover: "Kulit Kempen",
    ratioProduct: "Produk / Logo",
    ratioGallery: "Galeri / Gaya Hidup",
    prevYear: "Tahun Sebelumnya",
    prevMonth: "Bulan Sebelumnya",
    nextMonth: "Bulan Seterusnya",
    nextYear: "Tahun Seterusnya",
    timeLabel: "Masa",
    today: "Hari Ini",
    done: "Selesai",
  },
};

export default ms;
